"use strict";
/// <reference path="WorkflowModel.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowManager = void 0;
const tslib_1 = require("tslib");
const $ = require("jquery");
require("@progress/kendo-ui");
const Utilities_1 = require("../../javascript/Utilities");
const ej2_diagrams_1 = require("@syncfusion/ej2-diagrams");
require("@syncfusion/ej2-diagrams/styles/diagram/bootstrap.css");
require("@syncfusion/ej2-diagrams/styles/diagram/fabric.css");
const WorkflowModel_1 = require("./WorkflowModel");
const SessionStorageManager_1 = require("../../javascript/SessionStorageManager");
//#region Enums
var WorkflowShapeId;
(function (WorkflowShapeId) {
    WorkflowShapeId[WorkflowShapeId["Start"] = 0] = "Start";
    WorkflowShapeId[WorkflowShapeId["End"] = 1] = "End";
    WorkflowShapeId[WorkflowShapeId["Activity"] = 2] = "Activity";
    WorkflowShapeId[WorkflowShapeId["Fork"] = 3] = "Fork";
    WorkflowShapeId[WorkflowShapeId["Wait"] = 4] = "Wait";
    WorkflowShapeId[WorkflowShapeId["View"] = 5] = "View";
    WorkflowShapeId[WorkflowShapeId["Gui"] = 6] = "Gui";
    WorkflowShapeId[WorkflowShapeId["DynamicFork"] = 7] = "DynamicFork";
    WorkflowShapeId[WorkflowShapeId["DynamicWait"] = 8] = "DynamicWait";
})(WorkflowShapeId || (WorkflowShapeId = {}));
var VisualShapeId;
(function (VisualShapeId) {
    VisualShapeId[VisualShapeId["Text"] = 0] = "Text";
    VisualShapeId[VisualShapeId["Rectangle"] = 1] = "Rectangle";
})(VisualShapeId || (VisualShapeId = {}));
var ConnectorId;
(function (ConnectorId) {
    ConnectorId[ConnectorId["Orthogonal"] = 0] = "Orthogonal";
    ConnectorId[ConnectorId["Straight"] = 1] = "Straight";
})(ConnectorId || (ConnectorId = {}));
var WfMode;
(function (WfMode) {
    WfMode[WfMode["Edit"] = 0] = "Edit";
    WfMode[WfMode["View"] = 1] = "View";
})(WfMode || (WfMode = {}));
var WfDetailLevel;
(function (WfDetailLevel) {
    WfDetailLevel[WfDetailLevel["Detailed"] = 0] = "Detailed";
    WfDetailLevel[WfDetailLevel["Overall"] = 1] = "Overall";
})(WfDetailLevel || (WfDetailLevel = {}));
//#endregion Enums
class SearchProperty {
    constructor(Id, Property) {
        this.Id = Id;
        this.Property = Property;
    }
}
class SearchResult {
    constructor() {
        this.Properties = [];
    }
    get TypeTitle() {
        let title = "";
        if (this.Type === "Node")
            title = Utilities_1.synUtil.Strings.getValue("wf_search_node_type");
        else if (this.Type === "Variable")
            title = Utilities_1.synUtil.Strings.getValue("wf_search_variable_type");
        else if (this.Type === "Connector")
            title = Utilities_1.synUtil.Strings.getValue("wf_search_connector_type");
        return title;
    }
}
class HistoryObject {
    constructor(Worklow, SelectedItemIds, DetailLevel) {
        this.Worklow = Worklow;
        this.SelectedItemIds = SelectedItemIds;
        this.DetailLevel = DetailLevel;
    }
}
class WorkflowManager {
    //#endregion MEMBER VARIABLES
    //#region CONTRUCTORS
    constructor(workflowjQuery) {
        this.workflowjQuery = workflowjQuery;
        this.m_searchResultMap = [];
        this.m_selectedProperties = [];
        this.m_historyStack = [];
        this.m_historyStackPosition = -1;
        this.m_pasteCounter = 0;
        this.m_forPreview = false;
        this.m_historyIsChanging = false;
        this.m_ignoreHistoryChange = false;
        this.m_ignoreModelManipulation = false;
        this.m_ignoreSearchResultChange = false;
        this.m_workFlowModelHasChanged = false;
        this.m_diagram = undefined;
        let linearGradient;
        linearGradient = {
            x1: 0,
            y1: 50,
            x2: 100,
            y2: 50,
            stops: [{
                    color: '#E6E6E6',
                    offset: 0
                },
                {
                    color: '#ffffff',
                    offset: 100
                }
            ],
            type: 'Linear'
        };
        this.m_workflowShapes = [
            {
                id: WorkflowShapeId[WorkflowShapeId.Start],
                shape: {
                    type: "Flow",
                    shape: "Terminator",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "START" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.Start],
                },
                height: 50,
                width: 125,
                addInfo: {
                    tooltip: "Bei START beginnt die Ausführung des Workflows. Der START-Shape darf nur einmal pro Workflow existieren."
                },
                style: {
                    fill: "white"
                }
            }, {
                id: WorkflowShapeId[WorkflowShapeId.End],
                shape: {
                    type: "Flow",
                    shape: "Terminator",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "END", }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.End],
                },
                height: 50,
                width: 125,
                addInfo: {
                    tooltip: "Bei END endet der Workflow. Es wird auf alle eingehenden Verzweigungen gewartet bis der Workflow beendet wird. Der END-Shape darf nur einmal pro Workflow existieren."
                },
                style: {
                    fill: "white"
                }
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.Activity],
                shape: {
                    type: "Basic",
                    shape: "Rectangle",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "ACTIVITY" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.Activity],
                },
                height: 75,
                width: 125,
                addInfo: {
                    tooltip: "ACTIVITY führt die über \"Choose Function\" festgelegte Funktion aus. Dabei werden die gesetzen Ein- und Ausgabeparameter in \"Sheet Data\" berücksichtigt."
                },
                style: {
                    fill: "white"
                }
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.Gui],
                shape: {
                    type: "Basic",
                    shape: "Rectangle",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false }, content: "GUI" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.Gui],
                },
                style: {
                    gradient: linearGradient,
                    fill: "white"
                },
                height: 75,
                width: 125
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.Fork],
                shape: {
                    type: "Basic",
                    shape: "Ellipse",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "FORK" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.Fork],
                },
                height: 62,
                width: 62,
                addInfo: {
                    tooltip: "Bei FORK verzweigt der Workflow so, daß alle ausgehenden Verzweigungen ausgeführt werden."
                },
                style: {
                    fill: "white"
                }
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.Wait],
                shape: {
                    type: "Basic",
                    shape: "Ellipse",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "WAIT" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.Wait],
                },
                height: 62,
                width: 62,
                addInfo: {
                    tooltip: "Bei WAIT laufen alle eingehenden Verzweigungen zusammen. Der Workflow wird an dieser Stelle erst fortgesetzt wenn alle Verzweigungen den WAIT-Shape erreicht haben."
                },
                style: {
                    fill: "white"
                }
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.DynamicFork],
                shape: {
                    type: "Basic",
                    shape: "Decagon",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "DYNFORK" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.DynamicFork],
                },
                height: 62,
                width: 62,
                addInfo: {
                    tooltip: "DYNFORK (dynamisches Fork) führt für jedes Element in der angegebenen Liste die Activities bis DYNWAIT parallel aus."
                },
                style: {
                    fill: "white"
                }
            },
            {
                id: WorkflowShapeId[WorkflowShapeId.DynamicWait],
                shape: {
                    type: "Basic",
                    shape: "Decagon"
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "DYNWAIT" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.DynamicWait],
                },
                height: 62,
                width: 62,
                addInfo: {
                    tooltip: "DYNWAIT (dynamisches Wait) wartet auf alle parallele Ausführungen seit dem letzten DYNFORK."
                },
                style: {
                    fill: "white"
                }
            },
        ];
        this.m_viewShapes = [
            {
                id: WorkflowShapeId[WorkflowShapeId.View],
                shape: {
                    type: "Basic",
                    shape: "Rectangle",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "View" }],
                data: {
                    shapeId: WorkflowShapeId[WorkflowShapeId.View],
                },
                height: 150,
                width: 250,
                addInfo: {
                    tooltip: "VIEW fasst andere Shapes visuell zusammen um bestehende Workflows übersichtlicher zu gestalten. Dabei werden VIEW-Shapes in einem neuen Graphen verbunden und bestehende Shapes durch einen VIEW-Shape referenziert."
                },
                style: {
                    fill: "white"
                }
            }
        ];
        this.m_visualShapes = [
            {
                id: VisualShapeId[VisualShapeId.Text],
                shape: {
                    type: "Path",
                    data: "M0 0 L200 0 L200 200 L0 200 Z",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "Aa" }],
                style: {
                    strokeColor: "transparent",
                    fill: "transparent",
                    color: "black"
                },
                data: {
                    isDesignShape: true,
                    shapeId: VisualShapeId[VisualShapeId.Text],
                },
                height: 150,
                width: 150,
                addInfo: {
                    tooltip: "Textlabel"
                }
            },
            {
                id: VisualShapeId[VisualShapeId.Rectangle],
                shape: {
                    type: "Basic",
                    shape: "Rectangle",
                },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, content: "TextBox", horizontalAlignment: WorkflowModel_1.HorizontalAlignment.Center, verticalAlignment: WorkflowModel_1.VerticalAlignment.Center }],
                style: {
                    fill: "white",
                },
                data: {
                    shapeId: VisualShapeId[VisualShapeId.Rectangle],
                },
                height: 150,
                width: 250,
                addInfo: {
                    tooltip: "Textbox"
                },
            }
        ];
        // Initialize the connectors for the connector palette
        // Important: No data property to save the shapeId. id must be connector type! (So only two connectors possible)
        this.m_connectors = [
            {
                id: "Orthogonal", type: "Orthogonal", sourcePoint: { x: 0, y: 0 }, targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" }, style: { strokeWidth: 1 },
                annotations: [{ style: { color: "#000", fill: "transparent", fontSize: 12, bold: false, }, }],
                constraints: ej2_diagrams_1.ConnectorConstraints.Default
            },
        ];
        this.m_colorPickerFill = undefined;
        this.m_colorPickerText = undefined;
        this.m_colorPickerBorder = undefined;
        this.m_verticalAlign = undefined;
        this.m_horizontalAlign = undefined;
        // Inject Diagram modules
        ej2_diagrams_1.Diagram.Inject(ej2_diagrams_1.PrintAndExport, ej2_diagrams_1.Snapping, ej2_diagrams_1.ConnectorBridging, ej2_diagrams_1.ConnectorEditing); //, LineRouting, ConnectorEditing, UndoRedo); //UndoRedo, PrintAndExport, Snapping);
    }
    get Mode() {
        return this.m_mode;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    checkPropertyChange(elemId, id, type, property, value) {
        let that = this;
        let refreshSearchGrid = false;
        let searchText = that.m_$searchInput.val().toString().toLowerCase();
        if (that.m_searchResultDialog) {
            if (value === undefined || value === undefined)
                value = "";
            let searchResult = that.getSearchResult(elemId, id, type, property);
            if (searchResult) {
                if (!value.toLocaleLowerCase().includes(searchText)) {
                    that.clearSearchMark(searchResult);
                    searchResult = that.removeSearchProperty(elemId, id, type, property);
                    if (searchResult)
                        that.markSearchResult(searchResult);
                    refreshSearchGrid = true;
                }
            }
            else {
                if (value.toLocaleLowerCase().includes(searchText)) {
                    let searchResult = that.addSearchResult(elemId, id, type, property);
                    that.markSearchResult(searchResult);
                    refreshSearchGrid = true;
                }
            }
        }
        if (refreshSearchGrid) {
            that.refreshSearchGrid();
        }
    }
    refreshSearchGrid() {
        let dataSource = new kendo.data.DataSource({
            data: this.m_searchResultMap,
            schema: {
                model: {
                    fields: {
                        TypeTitle: { type: "string" },
                        ElemId: { type: "string" },
                    }
                }
            }
        });
        this.m_searchGrid.setDataSource(dataSource);
    }
    getSearchResult(ElemId, Id, Type, Property) {
        let searchResult = undefined;
        for (let result of this.m_searchResultMap)
            if (result.ElemId === ElemId) {
                if (!Property)
                    searchResult = result;
                else {
                    for (let property of result.Properties)
                        if (property.Id === Id && property.Property === Property)
                            searchResult = result;
                }
            }
        return searchResult;
    }
    editWorkflow(workflowModel, instanceId, window) {
        let that = this;
        this.m_mode = WfMode.Edit;
        this.m_levelOfDetail = WfDetailLevel.Detailed;
        this.m_instanceId = instanceId;
        this.setWorkflow(workflowModel);
        that.m_workFlowModelHasChanged = false;
        that.m_$saveButton.attr("disabled", "disabled").addClass("k-state-disabled");
        window.keydown((e) => {
            if (e.ctrlKey) {
                if (e.keyCode == 90 || e.keyCode == 89) { // undo/redo
                    e.stopPropagation();
                    e.preventDefault();
                }
                else if (e.keyCode == 83) { // save
                    e.stopPropagation();
                    e.preventDefault();
                    that.saveWorkflow(false);
                }
            }
        });
    }
    viewWorkflow(workflowModel, colorizeWorkflow, forPreview = false) {
        this.m_mode = WfMode.View;
        let viewNodes = workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.ViewNode);
        if (viewNodes != undefined && viewNodes.length > 0)
            this.m_levelOfDetail = WfDetailLevel.Overall;
        else
            this.m_levelOfDetail = WfDetailLevel.Detailed;
        this.m_forPreview = forPreview;
        if (colorizeWorkflow)
            this.colorizeWorkflow(workflowModel);
        this.setWorkflow(workflowModel);
    }
    clearProperties() {
        if (!this.m_forPreview) {
            this.m_$propertiesMenu.addClass("wfhideproperty");
            this.m_$propertiesMenu.empty();
            this.m_$propertiesContainer.empty();
        }
    }
    setProperties(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            if (id && !that.m_forPreview) {
                let currentNode = that.m_workflowModel.NodeList.find(node => node.Id === id);
                if (currentNode) {
                    let propertyIdItem = new PropertyIdItem(that, "Id", currentNode, id);
                    propertyIdItem.init(that.m_$propertiesContainer);
                    that.m_selectedProperties.push(propertyIdItem);
                    if (!(currentNode instanceof WorkflowModel_1.WfTextBoxNode) && !(currentNode instanceof WorkflowModel_1.WfTextLabelNode)) {
                        if (currentNode instanceof WorkflowModel_1.ViewNode) {
                            let propertyReferencedShapeItem = new PropertyReferencedShapesItem(that, "ReferencedShapes", currentNode);
                            propertyReferencedShapeItem.init(that.m_$propertiesContainer);
                            that.m_selectedProperties.push(propertyReferencedShapeItem);
                        }
                        else {
                            let propertyViewItem = new PropertyViewItem(that, [currentNode]);
                            propertyViewItem.init(that.m_$propertiesContainer);
                            that.m_selectedProperties.push(propertyViewItem);
                        }
                        if (currentNode instanceof WorkflowModel_1.ActivityNode)
                            yield that.setActivityProperties(currentNode);
                        else if (currentNode instanceof WorkflowModel_1.GuiNode)
                            that.setGuiProperties(currentNode);
                        else if (currentNode instanceof WorkflowModel_1.DynamicForkNode)
                            that.setDynamicForkProperties(currentNode);
                    }
                }
            }
        });
    }
    addHistoryObject() {
        if (!this.m_ignoreHistoryChange) {
            if (this.m_historyStack.length > 0) {
                this.m_workFlowModelHasChanged = true;
                this.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            }
            if (this.m_historyStackPosition != this.m_historyStack.length - 1)
                this.m_historyStack.splice(this.m_historyStackPosition + 1);
            let selItemIds = [];
            for (let elem of this.m_diagram.selectedItems.nodes) {
                selItemIds.push(elem.addInfo["wfelemid"]);
            }
            for (let elem of this.m_diagram.selectedItems.connectors) {
                selItemIds.push(elem.addInfo["wfelemid"]);
            }
            let wf = this.m_workflowModel.clone();
            this.updateSegments(wf);
            this.m_historyStack.push(new HistoryObject(wf, selItemIds, this.m_levelOfDetail));
            this.m_historyStackPosition += 1;
            if (this.m_historyStackPosition > 0)
                this.m_$undoButton.removeAttr("disabled").removeClass("k-state-disabled");
            this.m_$redoButton.attr("disabled", "disabled").addClass("k-state-disabled");
        }
    }
    static convertDirectionNumberToString(iDirection) {
        switch (iDirection) {
            case 0:
                return "in";
            case 1:
                return "out";
            case 2:
                return "inout";
            default:
                return "";
        }
    }
    static convertRequiredNumberToString(iDirection) {
        switch (iDirection) {
            case 0:
                return "mandatory";
            case 1:
                return "optional";
            default:
                return "";
        }
    }
    removeSearchProperty(ElemId, Id, Type, Property) {
        let that = this;
        let srIdx = that.m_searchResultMap.findIndex(elem => elem.ElemId === ElemId);
        if (srIdx != -1) {
            let sr = that.m_searchResultMap[srIdx];
            let propIdx = sr.Properties.findIndex(item => item.Id === Id && item.Property === Property);
            if (propIdx != -1)
                sr.Properties.splice(propIdx, 1);
            if (sr.Properties.length === 0) {
                that.m_searchResultMap.splice(srIdx, 1);
                return undefined;
            }
            return sr;
        }
        return undefined;
    }
    addSearchResult(ElemId, Id, Type, Property) {
        let that = this;
        let sr = that.m_searchResultMap.find(elem => elem.ElemId === ElemId);
        if (!sr) {
            sr = new SearchResult();
            sr.ElemId = ElemId;
            sr.Type = Type;
            that.m_searchResultMap.push(sr);
        }
        sr.Properties.push(new SearchProperty(Id, Property));
        return sr;
    }
    close(checkIn) {
        let close = true;
        if (this.m_workFlowModelHasChanged) {
            close = window.confirm(Utilities_1.synUtil.Strings.getValue("askcloseworkfloweditor"));
        }
        if (close) {
            this.closeSearchDialog();
            this.m_diagram.destroy();
            if (checkIn && this.m_instanceId) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceUndoCheckOut") + this.m_instanceId,
                    cleanUp: function () {
                    }
                });
            }
        }
        return close;
    }
    updateViewConnections(changedViewNode, updateDiagram) {
        let that = this;
        that.m_ignoreHistoryChange = true;
        let existingConnections = that.m_workflowModel.ConnectorList.filter(connector => connector.IsViewNode && (connector.SourceNodeId === changedViewNode.Id || connector.TargetNodeId === changedViewNode.Id));
        let connectorsToRemove = [];
        for (let connector of existingConnections) {
            let connectionFound = false;
            if (connector.SourceNodeId === changedViewNode.Id) {
                let targetViewNode = that.m_workflowModel.NodeList.find(node => node.Id == connector.TargetNodeId);
                let outConnectors = that.m_workflowModel.getReferencedOutConnections(changedViewNode);
                for (let outConnector of outConnectors) {
                    if (targetViewNode.ReferencedShapes.indexOf(outConnector.TargetNodeId) != -1) {
                        connectionFound = true;
                    }
                }
                if (!connectionFound)
                    connectorsToRemove.push(connector);
            }
            else {
                let targetViewNode = that.m_workflowModel.NodeList.find(node => node.Id == connector.SourceNodeId);
                let outConnectors = that.m_workflowModel.getReferencedOutConnections(targetViewNode);
                for (let outConnector of outConnectors) {
                    if (changedViewNode.ReferencedShapes.indexOf(outConnector.TargetNodeId) != -1) {
                        connectionFound = true;
                    }
                }
                if (!connectionFound)
                    connectorsToRemove.push(connector);
            }
        }
        for (let connectorToRemove of connectorsToRemove) {
            let idx = that.m_workflowModel.ConnectorList.indexOf(connectorToRemove);
            if (idx != -1) {
                that.m_workflowModel.ConnectorList.splice(idx, 1);
                if (updateDiagram)
                    that.m_diagram.remove(that.getDiagramObjectById(connectorToRemove.Id));
            }
        }
        let addedConnectors = that.m_workflowModel.addConnectionsBetweenViewNodes();
        if (updateDiagram)
            for (let addedConnector of addedConnectors)
                that.addWfConnector(addedConnector);
        that.m_ignoreHistoryChange = false;
    }
    printWorkFlow() {
        if (this.m_diagram) {
            let options = {
                mode: "Data",
                region: "Content",
                multiplePage: false,
            };
            this.m_diagram.print(options);
        }
    }
    toggleView() {
        var _a, _b;
        if (this.m_diagram) {
            if (this.m_levelOfDetail === WfDetailLevel.Detailed) {
                this.m_$viewButton.children().addClass("pressedViewButtonColor");
                this.m_levelOfDetail = WfDetailLevel.Overall;
                (_a = this.m_$drawConnnectorButton) === null || _a === void 0 ? void 0 : _a.hide();
            }
            else {
                this.m_$viewButton.children().removeClass("pressedViewButtonColor");
                this.m_levelOfDetail = WfDetailLevel.Detailed;
                (_b = this.m_$drawConnnectorButton) === null || _b === void 0 ? void 0 : _b.show();
            }
            let buttontitle = this.m_levelOfDetail === WfDetailLevel.Detailed ? Utilities_1.synUtil.Strings.getValue("wf_overview") : Utilities_1.synUtil.Strings.getValue("wf_detailed");
            this.m_$viewButton.prop("title", buttontitle);
            this.m_diagram.clearHighlighter();
            this.m_diagram.clearHistory();
            this.m_diagram.clearSelection();
            this.m_diagram.clearSelectorLayer();
            this.m_diagram.destroy();
            this.createDiagram();
            this.setWorkflowModel();
            this.updateSelection();
            if (!this.m_forPreview)
                this.search();
        }
    }
    //#endregion MEMBER METHODS
    //#region Helpers
    undo() {
        let command = this.m_diagram.commandManager.commands.find(c => c.name === "undo");
        if (command.canExecute())
            command.execute();
    }
    redo() {
        let command = this.m_diagram.commandManager.commands.find(c => c.name === "redo");
        if (command.canExecute())
            command.execute();
    }
    remove() {
        let command = this.m_diagram.commandManager.commands.find(c => c.name === "delete");
        if (command.canExecute())
            command.execute();
    }
    markAllSearchResults() {
        let that = this;
        if (that.m_searchResultMap) {
            for (let searchResult of that.m_searchResultMap)
                that.markSearchResult(searchResult);
        }
    }
    updateSearchResultSelection(elemId, id, type, property) {
        let that = this;
        if (that.m_searchResultMap && that.m_searchResultMap.length > 0 && that.m_searchGrid) {
            let items = that.m_searchGrid.items();
            if (items) {
                if (elemId) {
                    for (let item of items) {
                        let elem = that.m_searchGrid.dataItem(item);
                        if (elem["ElemId"] === elemId) {
                            that.m_ignoreSearchResultChange = true;
                            that.m_searchGrid.select(item);
                            return;
                        }
                    }
                    that.m_ignoreSearchResultChange = true;
                    that.m_searchGrid.clearSelection();
                }
                else {
                    that.m_ignoreSearchResultChange = true;
                    that.m_searchGrid.clearSelection();
                }
            }
        }
    }
    markSearchResult(searchResult) {
        let that = this;
        for (let property of searchResult.Properties) {
            if (searchResult.Type === "Variable") {
                if (that.m_diagram.selectedItems.nodes.length === 0 &&
                    that.m_diagram.selectedItems.connectors.length === 0) {
                    //Nothing selected variables must be shown
                    for (let selectedProperty of that.m_selectedProperties) {
                        if (selectedProperty instanceof PropertyVariableItem) {
                            if (selectedProperty.variable.Id === property.Id)
                                selectedProperty.markSearchResult(property.Property);
                        }
                    }
                }
            }
            else if (searchResult.Type === "Node") {
                switch (property.Property) {
                    case "Id":
                        let propItem = that.m_selectedProperties.find(item => item instanceof PropertyIdItem && item.NodeId === searchResult.ElemId);
                        if (propItem)
                            propItem.markSearchResult();
                        break;
                    case "Description":
                        let obj = that.getDiagramObjectById(searchResult.ElemId);
                        if (obj instanceof ej2_diagrams_1.Node) {
                            let node = obj;
                            node.annotations[0].style.fill = "#ffea00";
                        }
                        break;
                    case "GuiId":
                        let guiidPropItem = that.m_selectedProperties.find(item => item instanceof PropertyGuiIdItem && item.NodeId === searchResult.ElemId);
                        if (guiidPropItem)
                            guiidPropItem.markSearchResult();
                        break;
                    case "ThreadParamList":
                        let tplPropItem = that.m_selectedProperties.find(item => item instanceof PropertyItem && item.NodeId === searchResult.ElemId && item.propertyId === "ThreadParamList");
                        if (tplPropItem)
                            tplPropItem.markSearchResult();
                        break;
                    case "ThreadParamVariable":
                        let tpvPropItem = that.m_selectedProperties.find(item => item instanceof PropertyItem && item.NodeId === searchResult.ElemId && item.propertyId === "ThreadParamList");
                        if (tpvPropItem)
                            tpvPropItem.markSearchResult();
                        break;
                    default:
                        if (property.Property.startsWith("Param")) {
                            let propItem = that.m_selectedProperties.find(item => item instanceof PropertyParamItem && item.NodeId === searchResult.ElemId && item.propertyId === property.Id);
                            if (propItem)
                                propItem.markSearchResult();
                        }
                        break;
                }
            }
            else if (searchResult.Type === "Connector") {
                if (property.Property === "Description") {
                    let obj = that.getDiagramObjectById(searchResult.ElemId);
                    if (obj instanceof ej2_diagrams_1.Connector) {
                        let connector = obj;
                        connector.annotations[0].style.fill = "#ffea00";
                    }
                }
                else if (property.Property === "Path") {
                    let propItem = that.m_selectedProperties.find(item => item instanceof PropertyPathItem && item.ConnectorId === searchResult.ElemId);
                    if (propItem)
                        propItem.markSearchResult();
                }
            }
        }
        ;
    }
    clearSearchMark(searchResult) {
        let that = this;
        for (let property of searchResult.Properties) {
            if (searchResult.Type === "Variable") {
                if (that.m_diagram.selectedItems.nodes.length === 0 &&
                    that.m_diagram.selectedItems.connectors.length === 0) {
                    //Nothing selected variables must be shown
                    for (let selectedProperty of that.m_selectedProperties) {
                        if (selectedProperty instanceof PropertyVariableItem) {
                            if (selectedProperty.variable.Id === property.Id) {
                                selectedProperty.clearSearchResult(property.Property);
                            }
                        }
                    }
                    ;
                }
            }
            else if (searchResult.Type === "Node") {
                switch (property.Property) {
                    case "Id":
                        let idPropItem = that.m_selectedProperties.find(item => item instanceof PropertyIdItem && item.NodeId === searchResult.ElemId);
                        if (idPropItem)
                            idPropItem.clearSearchResult();
                        break;
                    case "Description":
                        let obj = that.getDiagramObjectById(searchResult.ElemId);
                        if (obj instanceof ej2_diagrams_1.Node) {
                            let node = obj;
                            node.annotations[0].style.fill = "transparent";
                        }
                        break;
                    case "GuiId":
                        let guiidPropItem = that.m_selectedProperties.find(item => item instanceof PropertyGuiIdItem && item.NodeId === searchResult.ElemId);
                        if (guiidPropItem)
                            guiidPropItem.clearSearchResult();
                        break;
                    case "ThreadParamList":
                        let tplPropItem = that.m_selectedProperties.find(item => item instanceof PropertyItem && item.NodeId === searchResult.ElemId && item.propertyId === "ThreadParamList");
                        if (tplPropItem)
                            tplPropItem.clearSearchResult();
                        break;
                    case "ThreadParamVariable":
                        let tpvPropItem = that.m_selectedProperties.find(item => item instanceof PropertyItem && item.NodeId === searchResult.ElemId && item.propertyId === "ThreadParamList");
                        if (tpvPropItem)
                            tpvPropItem.clearSearchResult();
                        break;
                    default:
                        if (property.Property.startsWith("Param")) {
                            let propItem = that.m_selectedProperties.find(item => item instanceof PropertyParamItem && item.NodeId === searchResult.ElemId && item.propertyId === property.Id);
                            if (propItem)
                                propItem.clearSearchResult();
                        }
                        else if (property.Property.startsWith("Variable")) {
                            let propItem = that.m_selectedProperties.find(item => item instanceof PropertyVariableItem && item.variable.Id === searchResult.ElemId);
                            if (propItem)
                                propItem.clearSearchResult(property.Property);
                        }
                        break;
                }
            }
            else if (searchResult.Type === "Connector") {
                if (property.Property === "Description") {
                    let obj = that.getDiagramObjectById(searchResult.ElemId);
                    if (obj instanceof ej2_diagrams_1.Connector) {
                        let connector = obj;
                        connector.annotations[0].style.fill = "transparent";
                    }
                }
                else if (property.Property === "Path") {
                    let propItem = that.m_selectedProperties.find(item => item instanceof PropertyPathItem && item.ConnectorId === searchResult.ElemId);
                    if (propItem)
                        propItem.clearSearchResult();
                }
            }
        }
    }
    search() {
        let that = this;
        if (that.m_$searchInput) {
            let searchText = that.m_$searchInput.val().toString().toLowerCase();
            that.clearAllSearchMarks();
            that.m_searchResultMap.splice(0);
            if (searchText) {
                if (that.m_levelOfDetail == WfDetailLevel.Detailed) {
                    for (let variable of that.m_workflowModel.VariableList) {
                        if (variable.Id && variable.Id.toLowerCase().includes(searchText))
                            that.addSearchResult(variable.Id, variable.Id, "Variable", "Variable:Id");
                        if (variable.Description && variable.Description.toLowerCase().includes(searchText))
                            that.addSearchResult(variable.Id, variable.Id, "Variable", "Variable:Description");
                        if (variable.Value && variable.Value.toLowerCase().includes(searchText))
                            that.addSearchResult(variable.Id, variable.Id, "Variable", "Variable:Value");
                    }
                    for (let connector of that.m_workflowModel.ConnectorList) {
                        if (connector.Description && connector.Description.toLowerCase().includes(searchText))
                            that.addSearchResult(connector.Id, connector.Id, "Connector", "Description");
                        if (connector.Path && connector.Path.toLowerCase().includes(searchText))
                            that.addSearchResult(connector.Id, connector.Id, "Connector", "Path");
                    }
                }
                for (let node of that.m_workflowModel.NodeList) {
                    if ((that.m_levelOfDetail === WfDetailLevel.Detailed && !(node instanceof WorkflowModel_1.ViewNode)) ||
                        (that.m_levelOfDetail === WfDetailLevel.Overall && node instanceof WorkflowModel_1.ViewNode)) {
                        if (node.Id && node.Id.toLowerCase().includes(searchText))
                            that.addSearchResult(node.Id, node.Id, "Node", "Id");
                        if (node.Description && node.Description.toLowerCase().includes(searchText))
                            that.addSearchResult(node.Id, node.Id, "Node", "Description");
                        if (node instanceof WorkflowModel_1.ActivityNode) {
                            for (let param of node.ParamList) {
                                if (param.Id && param.Id.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, param.Id, "Node", "Param:Id");
                                if (param.Value && param.Value.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, param.Id, "Node", "Param:Value");
                            }
                        }
                        else if (node instanceof WorkflowModel_1.GuiNode) {
                            if (node.GuiId && node.GuiId.toLowerCase().includes(searchText))
                                that.addSearchResult(node.Id, node.Id, "Node", "GuiId");
                            for (let param of node.ParamList) {
                                if (param.Id && param.Id.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, param.Id, "Node", "Param:Id");
                                if (param.Value && param.Value.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, param.Id, "Node", "Param:Value");
                            }
                        }
                        else if (node instanceof WorkflowModel_1.DynamicForkNode) {
                            if (node.ThreadParamList && node.ThreadParamList.toLowerCase().includes(searchText))
                                that.addSearchResult(node.Id, node.Id, "Node", "ThreadParamList");
                            if (node.ThreadParamVariable && node.ThreadParamVariable.toLowerCase().includes(searchText))
                                that.addSearchResult(node.Id, node.Id, "Node", "ThreadParamVariable");
                            for (let variable of node.VariableList) {
                                if (variable.Id && variable.Id.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, variable.Id, "Node", "Variable:Id");
                                if (variable.Description && variable.Description.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, variable.Id, "Node", "Variable:Description");
                                if (variable.Value && variable.Value.toLowerCase().includes(searchText))
                                    that.addSearchResult(node.Id, variable.Id, "Node", "Variable:Value");
                            }
                        }
                    }
                }
                if (!that.m_searchResultDialog) {
                    let windowData = Utilities_1.synUtil.popupWindow({
                        title: Utilities_1.synUtil.Strings.getValue("wf_searchresults"),
                        modal: false,
                    });
                    that.m_searchResultDialog = $("#" + windowData.windowID).data("kendoWindow");
                }
                else
                    that.m_searchResultDialog.toFront();
                let windowContainer = that.m_searchResultDialog.element;
                windowContainer.empty();
                that.m_searchResultDialog.unbind("close").bind("close", () => {
                    that.clearAllSearchMarks();
                    that.m_$searchInput.val("");
                    that.m_searchResultMap.splice(0);
                    that.m_searchResultDialog = undefined;
                });
                let grid = $("<div  />").appendTo(windowContainer);
                that.m_searchGrid = grid.kendoGrid({
                    dataSource: {
                        data: that.m_searchResultMap,
                        schema: {
                            model: {
                                fields: {
                                    TypeTitle: { type: "string", },
                                    ElemId: { type: "string" },
                                }
                            }
                        }
                    },
                    selectable: "row",
                    groupable: false,
                    sortable: false,
                    editable: false,
                    scrollable: false,
                    columns: [
                        { field: "TypeTitle", title: Utilities_1.synUtil.Strings.getValue("wf_search_type") },
                        { field: "ElemId", title: Utilities_1.synUtil.Strings.getValue("wf_search_elemid") },
                    ],
                    change: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        if (that.m_ignoreSearchResultChange) {
                            that.m_ignoreSearchResultChange = false;
                        }
                        else {
                            let entry = e.sender.dataItem(e.sender.select());
                            if (entry["Type"] === "Node") {
                                let obj = that.getDiagramObjectById(entry["ElemId"]);
                                if (obj instanceof ej2_diagrams_1.Node) {
                                    that.m_diagram.select([obj]);
                                    yield that.updateSelection(false);
                                    that.m_diagram.bringToCenter(new ej2_diagrams_1.Rect(obj.offsetX, obj.offsetY, obj.width, obj.height));
                                }
                            }
                            else if (entry["Type"] === "Connector") {
                                let obj = that.getDiagramObjectById(entry["ElemId"]);
                                if (obj instanceof ej2_diagrams_1.Connector) {
                                    that.m_diagram.select([obj]);
                                    yield that.updateSelection(false);
                                    if (obj.wrapper && obj.wrapper.bounds)
                                        that.m_diagram.bringToCenter(obj.wrapper.bounds);
                                }
                            }
                            else if (entry["Type"] === "Variable") {
                                that.m_diagram.clearSelection();
                                yield that.updateSelection(false);
                            }
                        }
                    }),
                }).data("kendoGrid");
                that.markAllSearchResults();
            }
            else {
                if (that.m_searchResultDialog) {
                    let windowContainer = that.m_searchResultDialog.element;
                    windowContainer.empty();
                }
            }
        }
    }
    clearAllSearchMarks() {
        let that = this;
        for (let searchResult of that.m_searchResultMap) {
            that.clearSearchMark(searchResult);
        }
    }
    initLayout() {
        let that = this;
        let containerDiagram = $("<div class='containerDiagram'>").appendTo(that.workflowjQuery);
        let wfContent = $("<div class='worklfowContent'>").appendTo(containerDiagram);
        let $sidebarButtonContainer;
        let $menuButtonContainer;
        let $searchContainer;
        let $searchButton;
        let $printButton;
        if (!that.m_forPreview && that.Mode === WfMode.Edit) {
            that.m_$sidebar = $("<div class='sidebar' style='display: flex;' tabindex='0'/>").appendTo(wfContent);
            $sidebarButtonContainer = $("<div class='buttonContainer'/>").appendTo(that.m_$sidebar);
            $searchContainer = $("<div class='searchContainer' />").appendTo($sidebarButtonContainer);
            that.m_$searchInput = $("<input type='text' class='wfInput k-textbox' />").appendTo($searchContainer);
            $searchButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('menuquicksexecutequery') + "'><i class='fa fa-search'></i></button>").appendTo($searchContainer);
        }
        let m_$centerContainer = $("<div class='worklfowCenterContainer' tabindex='1' />").appendTo(wfContent);
        let m_$menuContainer = $("<div class='worklfowMenuContainer' tabindex='2' />").appendTo(m_$centerContainer);
        $menuButtonContainer = $("<div class='buttonContainer'/>").appendTo(m_$menuContainer);
        that.m_$diagramContainer = $("<div class='worklfowDiagramContainer' tabindex='3'/>").appendTo(m_$centerContainer);
        if (that.Mode === WfMode.Edit) {
            that.m_$saveButton = $("<button class='k-button k-state-disabled' title='" + Utilities_1.synUtil.Strings.getValue('wf_save_button') + "' style='width:auto !important' disabled><i class='fa fa-save'></i></button>").appendTo($menuButtonContainer);
            that.m_$checkWorkflowButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_check_workflow_button') + "' style='width:auto !important'><i class='fa fa-check-square'></i></button>").appendTo($menuButtonContainer);
            that.m_$saveButton.on("click", (e) => {
                that.saveWorkflow(false);
            });
            that.m_$checkWorkflowButton.on("click", () => {
                that.checkWorkflow();
            });
        }
        else {
            if (!that.m_forPreview) {
                $searchContainer = $("<div class='searchContainer' />").appendTo($menuButtonContainer);
                that.m_$searchInput = $("<input type='text' class='wfInput k-textbox' />").appendTo($searchContainer);
                $searchButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('menuquicksexecutequery') + "'><i class='fa fa-search'></i></button>").appendTo($searchContainer);
            }
        }
        let buttonClass = that.m_forPreview ? "btn btn-default" : "k-button";
        let buttontitle = that.m_levelOfDetail === WfDetailLevel.Detailed ? Utilities_1.synUtil.Strings.getValue("wf_overview") : Utilities_1.synUtil.Strings.getValue("wf_detailed");
        this.m_$viewButton = $("<button class='" + buttonClass + "' title='" + buttontitle + "'><i class='fa fa-code-fork' style== ></i></button>").appendTo($menuButtonContainer);
        if (this.m_mode == WfMode.View) {
            let viewNodes = this.m_workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.ViewNode);
            if (viewNodes == undefined || viewNodes.length === 0)
                this.m_$viewButton.attr("disabled", "disabled").addClass("k-state-disabled");
        }
        $printButton = $("<button class='" + buttonClass + "' title='" + Utilities_1.synUtil.Strings.getValue('wf_print_button') + "' style='margin-right:15px' ><i class='fa fa-print'></i></button>").appendTo($menuButtonContainer);
        if (that.Mode === WfMode.Edit) {
            that.m_$removeButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue('wf_delete_button') + "'><i class='fa fa-remove'></i></button>").appendTo($menuButtonContainer);
            that.m_$drawConnnectorButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_draw_connector_button') + "' style='margin-right:15px'><i class='fa fa-level-down'></i></button>").appendTo($menuButtonContainer);
            that.m_$undoButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue('wf_undo_button') + "'><i class='fa fa-undo'></i></button>").appendTo($menuButtonContainer);
            that.m_$redoButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue('wf_redo_button') + "'><i class='fa fa-repeat'></i></button>").appendTo($menuButtonContainer);
            that.m_$undoButton.on("click", (e) => {
                that.undo();
            });
            that.m_$redoButton.on("click", (e) => {
                that.redo();
            });
            that.m_$removeButton.on("click", (e) => {
                that.remove();
            });
            that.m_$drawConnnectorButton.on("click", (e) => {
                let newDiagramConnector = JSON.parse(JSON.stringify(that.m_connectors.find(conncector => conncector.id == ConnectorId[ConnectorId.Orthogonal])));
                // Add connector defaults
                that.setConnectorDefaults(newDiagramConnector);
                that.setConnectorConstraints(newDiagramConnector);
                let newId = WorkflowModel_1.WorkflowModel.getNewElementId();
                newDiagramConnector.id = that.convertId(newId);
                newDiagramConnector.addInfo = { "wfelemid": newId, "wftype": "Connector" };
                that.m_diagram.drawingObject = newDiagramConnector;
                that.m_diagram.tool = ej2_diagrams_1.DiagramTools.DrawOnce;
                that.m_diagram.dataBind();
            });
            that.m_$buttonContainerWrapper = $("<div class='buttonContainerWrapper wfHide' />").appendTo($sidebarButtonContainer);
            let buttonContainerLabels = $("<div class='buttonContainerLabels' />").appendTo(that.m_$buttonContainerWrapper);
            that.m_$colorPickerFillLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_colorfill") + "</span>").appendTo(buttonContainerLabels);
            that.m_$fontSizeInputLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_fontsize") + "</span>").appendTo(buttonContainerLabels);
            that.m_$colorPickerTextLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_colortext") + "</span>").appendTo(buttonContainerLabels);
            that.m_$colorPickerBorderLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_colorborder") + "</span>").appendTo(buttonContainerLabels);
            that.m_$horizontalAlignLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_horizontalalign") + "</span>").appendTo(buttonContainerLabels);
            that.m_$verticalAlignLabel = $("<span class='buttonLabel'>" + Utilities_1.synUtil.Strings.getValue("wf_verticalalign") + "</span>").appendTo(buttonContainerLabels);
            let buttonContainerControls = $("<div class='buttonContainerControls' />").appendTo(that.m_$buttonContainerWrapper);
            that.m_$colorPickerFillContainer = $("<div class='colorPickerContainerFill' />").appendTo(buttonContainerControls);
            that.m_$fontSizeInputContainer = $("<div class='fontSizeInputContainer worklfowNumericInputContainer' />").appendTo(buttonContainerControls);
            that.m_$fontSizeInput = $("<input class='wfInput' type='number' disabled='disabled'/>").appendTo(that.m_$fontSizeInputContainer);
            that.m_$fontSizeUp = $("<button class='k-button k-state-disabled worklfowNumericInputButton' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_increasefontsize") + "'><i class='fa fa-arrow-up'></i></button>").appendTo(that.m_$fontSizeInputContainer);
            that.m_$fontSizeDown = $("<button class='k-button k-state-disabled worklfowNumericInputButton' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_decreasefontsize") + "'><i class='fa fa-arrow-down'></i></button>").appendTo(that.m_$fontSizeInputContainer);
            that.m_$colorPickerTextContainer = $("<div class='colorPickerContainerText' />").appendTo(buttonContainerControls);
            that.m_$colorPickerBorderContainer = $("<div class='colorPickerContainerBorder' />").appendTo(buttonContainerControls);
            that.m_$horizontalAlignContainer = $("<div class='horizontalAlignContainer' />").appendTo(buttonContainerControls);
            that.m_$verticalAlignContainer = $("<div class='verticalAlignContainer' />").appendTo(buttonContainerControls);
            let layoutContainerControls = $("<div class='layoutContainerControls' />").appendTo($sidebarButtonContainer);
            that.m_$alignHorizontalLeftButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_alignleft_button") + "'><i class='fa fa-align-left'></i></button>").appendTo(layoutContainerControls);
            that.m_$alignHorizontalCenterButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_aligncenter_button") + "'><i class='fa fa-align-center'></i></button>").appendTo(layoutContainerControls);
            that.m_$alignHorizontalRightButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_alignright_button") + "'><i class='fa fa-align-right'></i></button><br />").appendTo(layoutContainerControls);
            that.m_$alignVerticalTopButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_aligntop_button") + "'><i class='fa fa-align-left fa-rotate-90'></i></button>").appendTo(layoutContainerControls);
            that.m_$alignVerticalMiddleButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_alignmiddle_button") + "'><i class='fa fa-align-center fa-rotate-90'></i></button>").appendTo(layoutContainerControls);
            that.m_$alignVerticalBottomButton = $("<button class='k-button k-state-disabled' disabled='disabled' title='" + Utilities_1.synUtil.Strings.getValue("wf_alignbottom_button") + "'><i class='fa fa-align-right fa-rotate-90'></i></button><br />").appendTo(layoutContainerControls);
            that.m_$wfPaletteContainer = $("<div class='worklfowPaletteContainer' />").appendTo(that.m_$sidebar);
            that.m_$colorPickerFillContainer.empty();
            let colorPickerFillInput = $("<input class='colorPickerFill' />").appendTo(that.m_$colorPickerFillContainer);
            that.m_colorPickerFill = colorPickerFillInput.kendoColorPicker({
                opacity: true,
                value: "#ffffff",
                buttons: false,
                select: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] != "Node") {
                            node.style.fill = e.value;
                        }
                    }
                },
                change: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    for (let node of selectedNodes) {
                        let wfNode = that.getWfNodeById(selectedNodes[0].addInfo["wfelemid"]);
                        if (!(wfNode instanceof WorkflowModel_1.WfTextLabelNode)) {
                            node.style.fill = e.value;
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && e.value && e.value.startsWith("rgba")) {
                                let rgbaValue = e.value.substring(5, e.value.length - 1);
                                if (rgbaValue) {
                                    let tokens = rgbaValue.split(",");
                                    if (tokens.length = 4) {
                                        visualElem.ColorRed = parseFloat(tokens[0]);
                                        visualElem.ColorGreen = parseFloat(tokens[1]);
                                        visualElem.ColorBlue = parseFloat(tokens[2]);
                                        visualElem.Opacity = parseFloat(tokens[3]);
                                        visualElem.SetNewEtag();
                                        changed = true;
                                    }
                                }
                            }
                        }
                    }
                    if (changed)
                        that.addHistoryObject();
                },
                open: () => {
                    // Fix for cmdCopy/cmdPaste for colorPicker input field
                    $("input.k-color-value").attr("type", "text");
                },
                close: () => {
                    that.m_diagram.dataBind();
                },
            }).data("kendoColorPicker");
            // Set up/down fontSize, position and size buttons
            let holdIt = (btn, action, timeout, speedup) => {
                let originalTimeout = timeout;
                let timerHandle;
                let repeat = () => {
                    action();
                    timerHandle = window.setTimeout(repeat, timeout);
                    if (timeout / speedup >= 50) {
                        timeout = timeout / speedup;
                    }
                    else {
                        timeout = 50;
                    }
                };
                let start = () => {
                    repeat();
                };
                let stop = () => {
                    window.clearTimeout(timerHandle);
                    timeout = originalTimeout;
                    that.addHistoryObject();
                };
                btn.off("mousedown").on("mousedown", start);
                btn.off("mouseup").on("mouseup", stop);
                btn.off("mouseout").on("mouseout", stop);
            };
            let updateFontSize = () => {
                let newFontSize = that.m_$fontSizeInput.val().toString();
                if (newFontSize !== "") {
                    for (let node of that.m_diagram.selectedItems.nodes) {
                        if (node.addInfo["wftype"] !== "Node") {
                            node.annotations[0].style.fontSize = parseInt(newFontSize);
                            that.m_diagram.dataBind();
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && visualElem instanceof WorkflowModel_1.WfTextNode) {
                                visualElem.FontSize = parseInt(newFontSize);
                                visualElem.SetNewEtag();
                            }
                        }
                    }
                }
            };
            that.m_$fontSizeInput.on("change", (e) => {
                updateFontSize();
                let newFontSize = that.m_$fontSizeInput.val().toString();
                for (let node of that.m_diagram.selectedItems.nodes) {
                    if (node.addInfo["wftype"] !== "Node") {
                        let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                        if (visualElem && visualElem instanceof WorkflowModel_1.WfTextNode) {
                            visualElem.FontSize = parseInt(newFontSize);
                            visualElem.SetNewEtag();
                            that.addHistoryObject();
                        }
                    }
                }
            });
            holdIt(that.m_$fontSizeUp, () => {
                let currentFontSizeString = that.m_$fontSizeInput.val().toString();
                let newFontSize;
                if (currentFontSizeString === "")
                    newFontSize = 1;
                else
                    newFontSize = parseInt(currentFontSizeString) + 1;
                that.m_$fontSizeInput.val(newFontSize);
                updateFontSize();
            }, 1000, 2);
            holdIt(that.m_$fontSizeDown, () => {
                let currentFontSizeString = that.m_$fontSizeInput.val().toString();
                let newFontSize;
                if (currentFontSizeString === "")
                    newFontSize = 1;
                else if (parseInt(currentFontSizeString) > 1) {
                    newFontSize = parseInt(currentFontSizeString) - 1;
                    that.m_$fontSizeInput.val(newFontSize);
                    updateFontSize();
                }
            }, 1000, 2);
            // Set up colorPicker text
            that.m_$colorPickerTextContainer.empty();
            let colorPickerTextInput = $("<input class='colorPickerText' />").appendTo(that.m_$colorPickerTextContainer);
            that.m_colorPickerText = colorPickerTextInput.kendoColorPicker({
                opacity: true,
                value: "#ffffff",
                buttons: false,
                select: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] === "TextLabelNode" || node.addInfo["wftype"] === "TextBoxNode")
                            node.annotations[0].style.color = e.value;
                    }
                },
                change: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] != "Node") {
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && visualElem instanceof WorkflowModel_1.WfTextNode && e.value && e.value.startsWith("rgba")) {
                                let rgbaValue = e.value.substring(5, e.value.length - 1);
                                if (rgbaValue) {
                                    let tokens = rgbaValue.split(",");
                                    if (tokens.length = 4) {
                                        visualElem.TextColorRed = parseFloat(tokens[0]);
                                        visualElem.TextColorGreen = parseFloat(tokens[1]);
                                        visualElem.TextColorBlue = parseFloat(tokens[2]);
                                        visualElem.TextOpacity = parseFloat(tokens[3]);
                                        visualElem.SetNewEtag();
                                        changed = true;
                                    }
                                }
                            }
                        }
                    }
                    if (changed)
                        that.addHistoryObject();
                },
                open: () => {
                    // Fix for cmdCopy/cmdPaste for colorPicker input field
                    $("input.k-color-value").attr("type", "text");
                },
                close: () => {
                    that.m_diagram.dataBind();
                },
            }).data("kendoColorPicker");
            // Set up colorPicker border
            that.m_$colorPickerBorderContainer.empty();
            let colorPickerBorderInput = $("<input class='colorPickerBorder' />").appendTo(that.m_$colorPickerBorderContainer);
            that.m_colorPickerBorder = colorPickerBorderInput.kendoColorPicker({
                opacity: true,
                value: "#ffffff",
                buttons: false,
                select: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] === "TextBoxNode")
                            node.style.strokeColor = e.value;
                    }
                },
                change: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] != "Node") {
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && visualElem instanceof WorkflowModel_1.WfTextBoxNode && e.value && e.value.startsWith("rgba")) {
                                let rgbaValue = e.value.substring(5, e.value.length - 1);
                                if (rgbaValue) {
                                    let tokens = rgbaValue.split(",");
                                    if (tokens.length = 4) {
                                        visualElem.BorderColorRed = parseFloat(tokens[0]);
                                        visualElem.BorderColorGreen = parseFloat(tokens[1]);
                                        visualElem.BorderColorBlue = parseFloat(tokens[2]);
                                        visualElem.BorderOpacity = parseFloat(tokens[3]);
                                        visualElem.SetNewEtag();
                                        changed = true;
                                    }
                                }
                            }
                        }
                    }
                    if (changed)
                        that.addHistoryObject();
                },
                open: () => {
                    // Fix for cmdCopy/cmdPaste for colorPicker input field
                    $("input.k-color-value").attr("type", "text");
                },
                close: () => {
                    that.m_diagram.dataBind();
                },
            }).data("kendoColorPicker");
            that.m_$verticalAlignContainer.empty();
            let verticalAlignInput = $("<input class='verticalAlignInput'/>").appendTo(that.m_$verticalAlignContainer);
            that.m_verticalAlign = verticalAlignInput.kendoDropDownList({
                dataSource: [{ id: WorkflowModel_1.VerticalAlignment.Top, value: WorkflowModel_1.VerticalAlignment.Top }, { id: WorkflowModel_1.VerticalAlignment.Center, value: WorkflowModel_1.VerticalAlignment.Center }, { id: WorkflowModel_1.VerticalAlignment.Bottom, value: WorkflowModel_1.VerticalAlignment.Bottom }],
                dataTextField: "value",
                dataValueField: "id",
                change: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    let value = e.sender.value();
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] != "Node") {
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && visualElem instanceof WorkflowModel_1.WfTextBoxNode) {
                                let offset = node.annotations[0].offset;
                                visualElem.VerticalAlign = WorkflowModel_1.VerticalAlignment[value];
                                visualElem.SetNewEtag();
                                if (value == "Top") {
                                    offset.y = 0;
                                }
                                else if (value == "Center") {
                                    offset.y = 0.5;
                                }
                                else if (value == "Bottom") {
                                    offset.y = 1;
                                }
                                node.annotations[0].verticalAlignment = WorkflowModel_1.VerticalAlignment[value];
                                node.annotations[0].offset = offset;
                                changed = true;
                            }
                        }
                    }
                    if (changed)
                        that.addHistoryObject();
                }
            }).data("kendoDropDownList");
            that.m_$horizontalAlignContainer.empty();
            let horizontalAlignInput = $("<input class='horizontalAlignInput'/>").appendTo(that.m_$horizontalAlignContainer);
            that.m_horizontalAlign = horizontalAlignInput.kendoDropDownList({
                dataSource: [{ id: WorkflowModel_1.HorizontalAlignment.Left, value: WorkflowModel_1.HorizontalAlignment.Left }, { id: WorkflowModel_1.HorizontalAlignment.Center, value: WorkflowModel_1.HorizontalAlignment.Center }, { id: WorkflowModel_1.HorizontalAlignment.Right, value: WorkflowModel_1.HorizontalAlignment.Right }],
                dataTextField: "value",
                dataValueField: "id",
                change: (e) => {
                    let selectedNodes = that.m_diagram.selectedItems.nodes;
                    let changed = false;
                    let value = e.sender.value();
                    for (let node of selectedNodes) {
                        if (node.addInfo["wftype"] != "Node") {
                            let visualElem = that.getWfNodeById(node.addInfo["wfelemid"]);
                            if (visualElem && visualElem instanceof WorkflowModel_1.WfTextBoxNode) {
                                let offset = node.annotations[0].offset;
                                visualElem.HorizontalAlig = WorkflowModel_1.HorizontalAlignment[e.sender.value()];
                                visualElem.SetNewEtag();
                                if (value == "Left") {
                                    offset.x = 0;
                                }
                                else if (value == "Center") {
                                    offset.x = 0.5;
                                }
                                else if (value == "Right") {
                                    offset.x = 1;
                                }
                                node.annotations[0].horizontalAlignment = WorkflowModel_1.HorizontalAlignment[value];
                                node.annotations[0].offset = offset;
                                changed = true;
                            }
                        }
                    }
                    if (changed)
                        that.addHistoryObject();
                }
            }).data("kendoDropDownList");
            // Set up layout buttons
            that.m_$alignHorizontalLeftButton.off("click").on("click", (e) => {
                that.m_diagram.align("Left");
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
            that.m_$alignHorizontalCenterButton.off("click").on("click", (e) => {
                that.m_diagram.align("Center");
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
            that.m_$alignHorizontalRightButton.off("click").on("click", (e) => {
                that.m_diagram.align("Right", that.m_diagram.selectedItems.nodes);
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
            that.m_$alignVerticalTopButton.off("click").on("click", (e) => {
                that.m_diagram.align("Top");
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
            that.m_$alignVerticalMiddleButton.off("click").on("click", (e) => {
                that.m_diagram.align("Middle");
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
            that.m_$alignVerticalBottomButton.off("click").on("click", (e) => {
                that.m_diagram.align("Bottom");
                that.m_workFlowModelHasChanged = true;
                that.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
            });
        }
        else
            this.m_$viewButton.children().addClass("pressedViewButtonColor");
        this.m_$viewButton.off("click").on("click", (e) => {
            that.toggleView();
        });
        $printButton.off("click").on("click", (e) => {
            this.printWorkFlow();
        });
        if (!that.m_forPreview) {
            that.m_$properties = $("<div class='wf_properties' tabindex='4' />").appendTo(wfContent);
            let propCont = $("<div style='display: flex; align-items: center;' />").appendTo(that.m_$properties);
            let labelCont = $("<div style='padding: 0px 5px 0px 5px;' />").appendTo(propCont);
            let label = $("<label class='wf_properties_label'></label>").appendTo(labelCont);
            let propertyMenuContainer = $("<div class='wf_properties_menu_container' style='width: 100%;' />").appendTo(propCont);
            label.text(Utilities_1.synUtil.Strings.getValue("wf_properties_label"));
            that.m_$propertiesMenu = $("<div class='wfpropmenucontainer' style='float:right;' />").appendTo(propertyMenuContainer);
            that.m_$propertiesContainer = $("<div style='overflow-y:auto'/>").appendTo(that.m_$properties);
            $searchContainer.on("keyup", (e) => {
                if (e.which === 13)
                    $searchButton.trigger("click");
            });
            $searchButton.on("click", (e) => {
                that.search();
            });
        }
    }
    handleWorkflowError(errorMessage, errorNodeIds) {
        let that = this;
        // Restore color of nodes from model
        $.each(that.m_diagram.nameTable, (name, elem) => {
            if (elem instanceof ej2_diagrams_1.Node) {
                let wfNode = that.getWfNodeById(elem.addInfo["wfelemid"]);
                elem.style.fill = this.getRGBAColor(wfNode.ColorRed, wfNode.ColorGreen, wfNode.ColorBlue, wfNode.Opacity);
            }
        });
        // Color nodes with error
        let errorOccurred = errorMessage && errorMessage !== "";
        if (errorOccurred) {
            errorNodeIds.forEach(nodeId => {
                let elem = that.getDiagramObjectById(nodeId);
                if (elem instanceof ej2_diagrams_1.Node) {
                    elem.style.fill = that.getRGBAColor(230, 70, 70, 1.0);
                }
            });
            // Select first error node (selecting all error nodes is visually confusing)
            if (errorNodeIds.length > 0) {
                let errorNodeId = errorNodeIds[0];
                let elem = that.getDiagramObjectById(errorNodeId);
                if (elem) {
                    that.m_diagram.select([elem]);
                    that.updateSelection();
                }
            }
            // Show error in dialog
            $.errorDialog({ ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("workflowcheckfailed") + errorMessage });
        }
        return errorOccurred;
    }
    checkWorkflow() {
        let that = this;
        let wf = that.m_workflowModel.clone();
        wf.resolveExitList();
        // Run workflow checker
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("WorkflowCheckWorkflowIntegrity"),
            requestData: {
                workflow: WorkflowModel_1.WorkflowModel.toJSON(wf),
            },
            done: (data) => {
                let errorNodeIds = data[0];
                let errorMessage = data[1];
                if (!that.handleWorkflowError(errorMessage, errorNodeIds))
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("workflowcheckpassed"));
            },
            fail: (jqXHR, textStatus, errorThrown, url) => {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
            },
            cleanUp: () => {
            }
        });
    }
    saveWorkflow(checkIn) {
        let that = this;
        if (that.m_workFlowModelHasChanged) {
            let wf = that.m_workflowModel.clone();
            wf.resolveExitList();
            that.updatePositions(wf);
            that.updateSegments(wf);
            // Save workflow instance and run workflow checker if checkin
            Utilities_1.synUtil.getAJAXData({
                method: "PUT",
                url: Utilities_1.synUtil.getWSUrl("WorkflowSaveInstance"),
                requestData: {
                    workflow: WorkflowModel_1.WorkflowModel.toJSON(wf),
                    id: that.m_instanceId,
                    checkin: checkIn,
                    checkWorkflow: checkIn
                },
                done: (data) => {
                    if (checkIn) {
                        let errorNodeIds = data[0];
                        let errorMessage = data[1];
                        that.handleWorkflowError(errorMessage, errorNodeIds);
                    }
                    that.m_workFlowModelHasChanged = false;
                    that.m_$saveButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                    if (checkIn)
                        that.workflowjQuery.trigger("closeWorkFlow");
                },
                fail: (jqXHR, textStatus, errorThrown, url) => {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                },
                cleanUp: () => {
                }
            });
        }
    }
    // Update segments of connectors of workflowModel, based on segments of connectors of diagram
    updateSegments(workflowModel) {
        let that = this;
        for (let connector of that.m_diagram.connectors) {
            let wfConnector = workflowModel.ConnectorList.find(node => node.Id === connector.addInfo["wfelemid"]);
            if (wfConnector) {
                let segmentList = [];
                for (let segment of connector.segments) {
                    if (segment instanceof ej2_diagrams_1.OrthogonalSegment) {
                        let orthoSegment = segment;
                        if (orthoSegment.direction && orthoSegment.length) {
                            let wfSegment = new WorkflowModel_1.WfSegment;
                            wfSegment.Direction = orthoSegment.direction;
                            wfSegment.Length = orthoSegment.length;
                            segmentList.push(wfSegment);
                        }
                    }
                }
                wfConnector.SegmentList = segmentList;
            }
        }
    }
    updatePositions(workflowModel) {
        let that = this;
        for (let node of that.m_diagram.nodes) {
            let wfNode = workflowModel.NodeList.find(item => item.Id === node.addInfo["wfelemid"]);
            if (wfNode) {
                let changed = false;
                if (node.offsetX !== wfNode.PosX) {
                    wfNode.PosX = node.offsetX;
                    changed = true;
                }
                if (wfNode.PosY !== node.offsetY) {
                    wfNode.PosY = node.offsetY;
                    changed = true;
                }
                if (changed)
                    wfNode.SetNewEtag();
            }
        }
        for (let connector of that.m_diagram.connectors) {
            let wfConnector = workflowModel.ConnectorList.find(node => node.Id === connector.addInfo["wfelemid"]);
            if (wfConnector) {
                let changed = false;
                if (wfConnector.SourcePointPosX !== connector.sourcePoint.x) {
                    wfConnector.SourcePointPosX = connector.sourcePoint.x;
                    changed = true;
                }
                if (wfConnector.SourcePointPosY !== connector.sourcePoint.y) {
                    wfConnector.SourcePointPosY = connector.sourcePoint.y;
                    changed = true;
                }
                if (wfConnector.TargetPointPosX !== connector.targetPoint.x) {
                    wfConnector.TargetPointPosX = connector.targetPoint.x;
                    changed = true;
                }
                if (wfConnector.TargetPointPosY !== connector.targetPoint.y) {
                    wfConnector.TargetPointPosY = connector.targetPoint.y;
                    changed = true;
                }
                if (changed)
                    wfConnector.SetNewEtag();
            }
        }
    }
    markFutureNode(workflowModel, futureNodes, node) {
        let that = this;
        if (!futureNodes.find(n => n === node)) {
            futureNodes.push(node);
            node.ExitList.forEach(exit => {
                let linkNode = workflowModel.NodeList.find(node => node.Id === exit.Id);
                if (linkNode)
                    that.markFutureNode(workflowModel, futureNodes, linkNode);
            });
        }
    }
    colorizeWorkflow(workflowModel) {
        let that = this;
        workflowModel.resolveExitList();
        // Get list of active workflow nodes
        let activeNodes = workflowModel.NodeList.filter(node => node.IsActive);
        // Get list of future workflow nodes
        let futureNodes = [];
        activeNodes.forEach(node => {
            that.markFutureNode(workflowModel, futureNodes, node);
        });
        // Color all remaining nodes as already visited nodes, except view nodes
        workflowModel.NodeList.filter(node => !(node instanceof WorkflowModel_1.ViewNode)
            && !activeNodes.find(n => n.Id === node.Id) && !futureNodes.find(n => n.Id === node.Id)).forEach(node => {
            node.ColorMode = WorkflowModel_1.ColorMode.Visisted;
        });
        // Color all potential future nodes
        futureNodes.filter(node => !activeNodes.find(n => n.Id === node.Id)).forEach(node => {
            node.ColorMode = WorkflowModel_1.ColorMode.Future;
        });
        // Color all active nodes
        activeNodes.forEach(node => {
            node.ColorMode = WorkflowModel_1.ColorMode.Active;
        });
        // Special case end node: If there is no active node and end node was completed, then color it as active
        if (activeNodes.length == 0) {
            workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.EndNode && node.CompletedList.length > 0).forEach(node => {
                node.ColorMode = WorkflowModel_1.ColorMode.Active;
            });
        }
        // Color all view nodes according to their referenced nodes
        workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.ViewNode).forEach(node => {
            let viewNode = node;
            let activeNodes = false;
            let visitedNodes = false;
            let futureNodes = false;
            viewNode.ReferencedShapes.forEach(refNodeId => {
                let refNode = workflowModel.NodeList.find(node => node.Id === refNodeId);
                if (refNode) {
                    switch (refNode.ColorMode) {
                        case WorkflowModel_1.ColorMode.Active:
                            activeNodes = true;
                            break;
                        case WorkflowModel_1.ColorMode.Future:
                            futureNodes = true;
                            break;
                        case WorkflowModel_1.ColorMode.Visisted:
                            visitedNodes = true;
                            break;
                    }
                }
            });
            if (activeNodes) {
                // If there is at least one active node, the view node is marked as active node
                viewNode.ColorMode = WorkflowModel_1.ColorMode.Active;
            }
            else if (futureNodes) {
                // If there is no active node but future nodes, the view node is marked as future node
                viewNode.ColorMode = WorkflowModel_1.ColorMode.Future;
            }
            else if (visitedNodes) {
                // If there are just visited nodes, the view node is marked as visited node
                viewNode.ColorMode = WorkflowModel_1.ColorMode.Visisted;
            }
            else {
                viewNode.ColorMode = WorkflowModel_1.ColorMode.None;
            }
        });
    }
    setWorkflow(workflowModel) {
        this.m_workflowModel = workflowModel;
        this.initLayout();
        this.loadDiagram();
        this.updateSelection();
    }
    // Sets the default values of a connector
    setConnectorDefaults(obj) {
        if (obj.type === undefined)
            obj.type = "Orthogonal";
        if (obj.targetDecorator === undefined)
            obj.targetDecorator = { shape: "Arrow", width: 2, height: 2 };
        return obj;
    }
    getSymbolInfo(symbol) {
        let tooltip = "";
        if (symbol.addInfo)
            tooltip = symbol.addInfo["tooltip"];
        return {
            fit: false,
            description: {
                text: symbol.annotations && symbol.annotations.length > 0 ? symbol.annotations[0].content : "",
                overflow: "Wrap"
            },
            tooltip: tooltip
        };
    }
    getDiagramObjectById(id) {
        let object = undefined;
        $.each(this.m_diagram.nameTable, (name, elem) => {
            if (elem instanceof ej2_diagrams_1.Node || elem instanceof ej2_diagrams_1.Connector) {
                if (elem.addInfo["wfelemid"] === id) {
                    object = elem;
                    return false;
                }
            }
        });
        return object;
    }
    getWfNodeByConvertId(id) {
        let that = this;
        if (id)
            return that.m_workflowModel.NodeList.find(node => that.convertId(node.Id) === id);
        else
            return undefined;
    }
    getWfNodeById(id) {
        let that = this;
        if (id)
            return that.m_workflowModel.NodeList.find(node => node.Id === id);
        else
            return undefined;
    }
    getWfConnectorByConvertId(id) {
        let that = this;
        if (id)
            return that.m_workflowModel.ConnectorList.find(node => that.convertId(node.Id) === id);
        else
            return undefined;
    }
    getWfConnectorById(id) {
        let that = this;
        if (id)
            return that.m_workflowModel.ConnectorList.find(node => node.Id === id);
        else
            return undefined;
    }
    updateSelection(updateSearchList = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let selectedNodes = that.m_diagram.selectedItems.nodes;
            let selectedConnectors = that.m_diagram.selectedItems.connectors;
            that.m_selectedProperties.splice(0);
            that.clearProperties();
            if (that.m_mode === WfMode.Edit) {
                if (that.m_$buttonContainerWrapper) {
                    that.m_$buttonContainerWrapper.addClass("wfHide");
                    that.m_$fontSizeInputContainer.addClass("wfHide");
                    that.m_$fontSizeInputLabel.addClass("wfHide");
                    that.m_$colorPickerBorderContainer.addClass("wfHide");
                    that.m_$colorPickerBorderLabel.addClass("wfHide");
                    that.m_$colorPickerTextContainer.addClass("wfHide");
                    that.m_$colorPickerTextLabel.addClass("wfHide");
                    that.m_$colorPickerFillContainer.addClass("wfHide");
                    that.m_$colorPickerFillLabel.addClass("wfHide");
                    that.m_$verticalAlignContainer.addClass("wfHide");
                    that.m_$verticalAlignLabel.addClass("wfHide");
                    that.m_$horizontalAlignContainer.addClass("wfHide");
                    that.m_$horizontalAlignLabel.addClass("wfHide");
                }
                that.m_$removeButton.removeClass("k-state-disabled").removeAttr("disabled");
                // Update layout buttons
                if (selectedNodes.length < 2) {
                    that.m_$alignHorizontalLeftButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    that.m_$alignHorizontalCenterButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    that.m_$alignHorizontalRightButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    that.m_$alignVerticalTopButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    that.m_$alignVerticalMiddleButton.attr("disabled", "disabled").addClass("k-state-disabled");
                    that.m_$alignVerticalBottomButton.attr("disabled", "disabled").addClass("k-state-disabled");
                }
                else {
                    that.m_$alignHorizontalLeftButton.removeAttr("disabled").removeClass("k-state-disabled");
                    that.m_$alignHorizontalCenterButton.removeAttr("disabled").removeClass("k-state-disabled");
                    that.m_$alignHorizontalRightButton.removeAttr("disabled").removeClass("k-state-disabled");
                    that.m_$alignVerticalTopButton.removeAttr("disabled").removeClass("k-state-disabled");
                    that.m_$alignVerticalMiddleButton.removeAttr("disabled").removeClass("k-state-disabled");
                    that.m_$alignVerticalBottomButton.removeAttr("disabled").removeClass("k-state-disabled");
                }
            }
            if (selectedNodes.length == 0 && selectedConnectors.length == 0) {
                if (that.m_levelOfDetail === WfDetailLevel.Detailed && !that.m_forPreview) {
                    //Nothing selected show global variables
                    that.setGlobalVariableProperties();
                    if (updateSearchList)
                        that.updateSearchResultSelection();
                    if (that.m_$removeButton)
                        that.m_$removeButton.addClass("k-state-disabled").attr("disabled", "disabled");
                }
            }
            else if (selectedNodes.length == 0) {
                if (selectedConnectors.length == 1) {
                    // Only one connector is selected show path variable
                    that.setConnectorProperties(selectedConnectors[0].addInfo["wfelemid"]);
                    if (updateSearchList)
                        that.updateSearchResultSelection(selectedConnectors[0].addInfo["wfelemid"]);
                }
            }
            else if (selectedConnectors.length == 0) {
                if (selectedNodes.length == 1) {
                    // Only one node is selected show properties
                    yield that.setProperties(selectedNodes[0].addInfo["wfelemid"]);
                    if (updateSearchList)
                        that.updateSearchResultSelection(selectedNodes[0].addInfo["wfelemid"]);
                    if (that.m_mode === WfMode.Edit && that.m_$buttonContainerWrapper) {
                        that.m_$buttonContainerWrapper.removeClass("wfHide");
                        let wfNode = that.getWfNodeById(selectedNodes[0].addInfo["wfelemid"]);
                        if (wfNode instanceof WorkflowModel_1.WfTextNode) {
                            if (wfNode instanceof WorkflowModel_1.WfTextBoxNode) {
                                that.m_$colorPickerBorderContainer.removeClass("wfHide");
                                that.m_$colorPickerBorderLabel.removeClass("wfHide");
                                that.m_$colorPickerTextContainer.removeClass("wfHide");
                                that.m_$colorPickerTextLabel.removeClass("wfHide");
                                that.m_$colorPickerFillContainer.removeClass("wfHide");
                                that.m_$colorPickerFillLabel.removeClass("wfHide");
                                that.m_$verticalAlignContainer.removeClass("wfHide");
                                that.m_$verticalAlignLabel.removeClass("wfHide");
                                that.m_$horizontalAlignContainer.removeClass("wfHide");
                                that.m_$horizontalAlignLabel.removeClass("wfHide");
                                if (that.m_colorPickerBorder)
                                    that.m_colorPickerBorder.color(kendo.parseColor(that.getRGBAColor(wfNode.BorderColorRed, wfNode.BorderColorGreen, wfNode.BorderColorBlue, wfNode.BorderOpacity), true));
                                if (that.m_horizontalAlign)
                                    that.m_horizontalAlign.value(wfNode.HorizontalAlig);
                                if (that.m_verticalAlign)
                                    that.m_verticalAlign.value(wfNode.VerticalAlign);
                            }
                            that.m_$fontSizeInput.removeClass("k-state-disabled").removeAttr("disabled");
                            that.m_$fontSizeUp.removeClass("k-state-disabled").removeAttr("disabled");
                            that.m_$fontSizeDown.removeClass("k-state-disabled").removeAttr("disabled");
                            that.m_$fontSizeInputContainer.removeClass("wfHide");
                            that.m_$fontSizeInputLabel.removeClass("wfHide");
                            that.m_$colorPickerTextContainer.removeClass("wfHide");
                            that.m_$colorPickerTextLabel.removeClass("wfHide");
                            that.m_$fontSizeInput.val(wfNode.FontSize);
                            // Update fill color selection
                            let shapeColor = that.getRGBAColor(wfNode.ColorRed, wfNode.ColorGreen, wfNode.ColorBlue, wfNode.Opacity);
                            if (shapeColor === "" || shapeColor === "none") {
                                let color = kendo.parseColor("#fff", true);
                                if (that.m_colorPickerFill)
                                    that.m_colorPickerFill.color(color);
                            }
                            else {
                                let color = kendo.parseColor(shapeColor, true);
                                if (that.m_colorPickerFill)
                                    that.m_colorPickerFill.color(color);
                            }
                            // Update text color selection
                            let textColor = that.getRGBAColor(wfNode.TextColorRed, wfNode.TextColorGreen, wfNode.TextColorBlue, wfNode.TextOpacity);
                            if (textColor === "" || textColor === "none") {
                                let color = kendo.parseColor("#fff", true);
                                if (that.m_colorPickerText)
                                    that.m_colorPickerText.color(color);
                            }
                            else {
                                let color = kendo.parseColor(textColor, true);
                                if (that.m_colorPickerText)
                                    that.m_colorPickerText.color(color);
                            }
                        }
                        else {
                            that.m_$colorPickerFillContainer.removeClass("wfHide");
                            that.m_$colorPickerFillLabel.removeClass("wfHide");
                            // Update fill color selection
                            let shapeColor = that.getRGBAColor(wfNode.ColorRed, wfNode.ColorGreen, wfNode.ColorBlue, wfNode.Opacity);
                            if (shapeColor === "" || shapeColor === "none") {
                                let color = kendo.parseColor("#fff", true);
                                if (that.m_colorPickerFill)
                                    that.m_colorPickerFill.color(color);
                            }
                            else {
                                let color = kendo.parseColor(shapeColor, true);
                                if (that.m_colorPickerFill)
                                    that.m_colorPickerFill.color(color);
                            }
                        }
                    }
                }
                else {
                    // More nodes are selected show common properties
                    let currentNodes = [];
                    for (let selectedNode of selectedNodes) {
                        currentNodes.push(that.m_workflowModel.NodeList.find(node => node.Id === selectedNode.addInfo["wfelemid"]));
                    }
                    let propertyViewItem = new PropertyViewItem(that, currentNodes);
                    propertyViewItem.init(that.m_$propertiesContainer);
                    that.m_selectedProperties.push(propertyViewItem);
                }
            }
            that.markAllSearchResults();
        });
    }
    createPalette() {
        let that = this;
        that.m_$wfPaletteContainer.empty();
        let wfpalette = $("<div class='worklfowPalette' id='worklfowPalette" + Utilities_1.synUtil.getGUID(true) + "'></div>").appendTo(that.m_$wfPaletteContainer);
        let palettes;
        if (that.m_levelOfDetail === WfDetailLevel.Detailed) {
            palettes = [
                { id: "workflow", expanded: true, symbols: that.m_workflowShapes, iconCss: "e-ddb-icons e-flow", },
                { id: "visual", expanded: true, symbols: that.m_visualShapes, iconCss: "e-ddb-icons e-basic", },
            ];
        }
        else {
            palettes = [
                { id: "view", expanded: true, symbols: that.m_viewShapes, iconCss: "e-ddb-icons e-basic", }
            ];
        }
        //Initializes the symbol palette
        let palette = new ej2_diagrams_1.SymbolPalette({
            expandMode: "Multiple", palettes: palettes,
            width: "100%", height: "100%", symbolHeight: 100, symbolWidth: 100,
            symbolMargin: { left: 15, right: 15, top: 15, bottom: 15 },
            getSymbolInfo: that.getSymbolInfo,
            enableAnimation: false,
        });
        palette.appendTo(wfpalette[0]);
        // Add "Aa" text to text shape
        $(".worklfowPaletteContainer #Text_container")
            .css("text-align", "center")
            .css("line-height", "101px")
            .prepend("<span style='pointer-events: none;'>Aa</span>");
        $(".worklfowPaletteContainer #Text_container canvas").css("display", "none");
    }
    setConnectorProperties(id) {
        let that = this;
        if (id) {
            let currentConnector = that.getWfConnectorById(id);
            if (currentConnector) {
                let item = new PropertyPathItem(that, currentConnector);
                item.init(that.m_$propertiesContainer);
                that.m_selectedProperties.push(item);
            }
        }
    }
    setDynamicForkProperties(currentNode) {
        let that = this;
        that.m_$propertiesMenu.removeClass("wfhideproperty");
        if (that.Mode === WfMode.Edit) {
            let addButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_addvariable_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-plus'></i></button>").appendTo(that.m_$propertiesMenu);
            addButton.on("click", (e) => {
                let newVariable = new WorkflowModel_1.Variable();
                currentNode.VariableList.push(newVariable);
                let property = new PropertyVariableItem(that, newVariable);
                property.init(that.m_$propertiesContainer);
            });
        }
        let expandButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_expand_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-expand'></i></button>").appendTo(that.m_$propertiesMenu);
        let collapsButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_collapse_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-compress'></i></button>").appendTo(that.m_$propertiesMenu);
        collapsButton.on("click", (e) => {
            that.m_$propertiesContainer.find(".additionalContainer").addClass("wfhideproperty");
        });
        expandButton.on("click", (e) => {
            that.m_$propertiesContainer.find(".additionalContainer").removeClass("wfhideproperty");
        });
        let tplitem = new PropertyItem(that, "ThreadParamList", currentNode, currentNode.ThreadParamList);
        tplitem.init(that.m_$propertiesContainer);
        let tpvitem = new PropertyItem(that, "ThreadParamVariable", currentNode, currentNode.ThreadParamVariable);
        tpvitem.init(that.m_$propertiesContainer);
        for (let variable of currentNode.VariableList) {
            let property = new PropertyVariableItem(that, variable);
            property.init(that.m_$propertiesContainer);
        }
    }
    setGlobalVariableProperties() {
        let that = this;
        that.m_$propertiesMenu.removeClass("wfhideproperty");
        if (that.Mode === WfMode.Edit) {
            let addButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_addvariable_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-plus'></i></button>").appendTo(that.m_$propertiesMenu);
            addButton.on("click", (e) => {
                let newVariable = new WorkflowModel_1.Variable();
                that.m_workflowModel.VariableList.push(newVariable);
                let property = new PropertyVariableItem(that, newVariable);
                property.init(that.m_$propertiesContainer);
                that.m_selectedProperties.push(property);
            });
        }
        let expandButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_expand_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-expand'></i></button>").appendTo(that.m_$propertiesMenu);
        let collapsButton = $("<button class='k-button' title='" + Utilities_1.synUtil.Strings.getValue('wf_collapse_button') + "' style='margin-left:3px;float: right;'><i class='fa fa-compress'></i></button>").appendTo(that.m_$propertiesMenu);
        collapsButton.on("click", (e) => {
            that.m_$propertiesContainer.find(".additionalContainer").addClass("wfhideproperty");
        });
        expandButton.on("click", (e) => {
            that.m_$propertiesContainer.find(".additionalContainer").removeClass("wfhideproperty");
        });
        for (let variable of that.m_workflowModel.VariableList) {
            let property = new PropertyVariableItem(that, variable);
            property.init(that.m_$propertiesContainer);
            that.m_selectedProperties.push(property);
        }
    }
    setGuiProperties(currentNode) {
        let that = this;
        let guiItem = new PropertyGuiIdItem(that, "GuiId", currentNode, currentNode.GuiId);
        guiItem.init(that.m_$propertiesContainer);
        that.m_selectedProperties.push(guiItem);
        if (currentNode.ParamList) {
            for (let param of currentNode.ParamList) {
                let item = new PropertyParamItem(that, param.Id, currentNode, param.Value, param.Direction, param.Required, param.Type);
                item.init(that.m_$propertiesContainer);
                that.m_selectedProperties.push(item);
            }
            ;
        }
    }
    setActivityProperties(currentNode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let functionParams;
            if (currentNode.FunctionId) {
                functionParams = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "GET",
                    url: Utilities_1.synUtil.getWSUrl("WorkflowGetWorkflowFunctionParameterData") + encodeURIComponent(currentNode.FunctionId),
                });
            }
            let functionIdItem = new PropertyFunctionIdItem(that, "FunctionId", currentNode);
            functionIdItem.init(that.m_$propertiesContainer);
            if (functionParams) {
                for (let functionParam of functionParams) {
                    let initValue = "";
                    let direction = WorkflowManager.convertDirectionNumberToString(functionParam.direction);
                    let required = WorkflowManager.convertRequiredNumberToString(functionParam.required);
                    if (currentNode.ParamList) {
                        let param = currentNode.ParamList.find(node => node.Id === functionParam.name);
                        if (param)
                            initValue = param.Value;
                    }
                    let item = new PropertyParamItem(that, functionParam.name, currentNode, initValue, direction, required, functionParam.typeName);
                    item.init(that.m_$propertiesContainer);
                    that.m_selectedProperties.push(item);
                }
            }
        });
    }
    closeSearchDialog() {
        if (this.m_searchResultDialog)
            this.m_searchResultDialog.close();
    }
    createDiagram() {
        let that = this;
        that.m_$diagramContainer.empty();
        let diagramId = "wfDiagram_" + Utilities_1.synUtil.getGUID(true);
        let pMD = $("<div id='" + diagramId + "' class='worklfowDiagram'></div>").appendTo(that.m_$diagramContainer);
        let gridlines = { lineColor: "#e0e0e0" };
        that.m_diagram = new ej2_diagrams_1.Diagram({
            width: "100%",
            height: "100%",
            constraints: ej2_diagrams_1.DiagramConstraints.Default & ~ej2_diagrams_1.DiagramConstraints.UndoRedo,
            snapSettings: {
                horizontalGridlines: gridlines,
                verticalGridlines: gridlines,
                constraints: that.Mode === WfMode.View ? ej2_diagrams_1.SnapConstraints.None : ej2_diagrams_1.SnapConstraints.All,
            },
            layers: [
                {
                    id: "textboxLayer",
                    visible: true,
                    objects: [],
                    lock: false,
                    zIndex: 2
                },
                {
                    id: "textlabelLayer",
                    visible: true,
                    objects: [],
                    lock: false,
                    zIndex: 1
                },
                {
                    id: "shapeLayer",
                    visible: true,
                    objects: [],
                    lock: false,
                    zIndex: 0
                },
            ],
            dragEnter: (e) => {
                if (e.element instanceof ej2_diagrams_1.Node || e.element instanceof ej2_diagrams_1.Connector) {
                    let guid = WorkflowModel_1.WorkflowModel.getNewElementId();
                    e.element.id = this.convertId(guid);
                    e.element.addInfo = { "wfelemid": guid };
                    if (e.element instanceof ej2_diagrams_1.Node) {
                        if (e.element.data.shapeId === VisualShapeId[VisualShapeId.Rectangle])
                            e.element.addInfo["wftype"] = "TextBoxNode";
                        else if (e.element.data.shapeId === VisualShapeId[VisualShapeId.Text])
                            e.element.addInfo["wftype"] = "TextLabelNode";
                        else
                            e.element.addInfo["wftype"] = "Node";
                    }
                    else
                        e.element.addInfo["wftype"] = "Connector";
                    that.m_diagram.dataBind();
                }
            },
            commandManager: {
                commands: [
                    {
                        name: "delete",
                        canExecute: () => {
                            return that.Mode === WfMode.Edit && (that.m_diagram.selectedItems.connectors.length > 0 || that.m_diagram.selectedItems.nodes.length > 0);
                        },
                        execute: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            that.m_ignoreHistoryChange = true;
                            let elementsToRemove = new Array();
                            for (let connector of that.m_diagram.selectedItems.connectors)
                                elementsToRemove.push(connector);
                            for (let node of that.m_diagram.selectedItems.nodes)
                                elementsToRemove.push(node);
                            for (let elem of elementsToRemove)
                                that.m_diagram.remove(elem);
                            that.m_ignoreHistoryChange = false;
                            that.addHistoryObject();
                            yield that.updateSelection();
                        }),
                        gesture: {
                            key: ej2_diagrams_1.Keys.Delete
                        }
                    },
                    {
                        name: "copy",
                        canExecute: () => {
                            return that.Mode === WfMode.Edit && (that.m_diagram.selectedItems.connectors.length > 0 || that.m_diagram.selectedItems.nodes.length > 0);
                        },
                        execute: () => {
                            that.m_pasteCounter = 0;
                            let wfNodes = new Array();
                            for (let node of that.m_diagram.selectedItems.nodes) {
                                let nodeId = node.addInfo["wfelemid"];
                                let clonedNode = that.getWfNodeById(nodeId).clone();
                                if (clonedNode instanceof WorkflowModel_1.ViewNode)
                                    clonedNode.ReferencedShapes.splice(0);
                                wfNodes.push(clonedNode);
                            }
                            for (let connector of that.m_diagram.selectedItems.connectors) {
                                let connectorId = connector.addInfo["wfelemid"];
                                let connectorToCopy = that.getWfConnectorById(connectorId);
                                if (connectorToCopy.SourceNodeId && wfNodes.findIndex(item => item.Id === connectorToCopy.SourceNodeId) == -1) {
                                    connectorToCopy.SourceNodeId = undefined;
                                    connectorToCopy.SourcePortId = undefined;
                                }
                                if (connectorToCopy.TargetNodeId && wfNodes.findIndex(item => item.Id === connectorToCopy.TargetNodeId) == -1) {
                                    connectorToCopy.TargetNodeId = undefined;
                                    connectorToCopy.TargetPortId = undefined;
                                }
                                wfNodes.push(connectorToCopy);
                            }
                            SessionStorageManager_1.SessionStorageManager.setItem(SessionStorageManager_1.SessionStorageType.WF_Clipboard, "copiedItems", wfNodes);
                            Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("wf_copy_notification"));
                        },
                        gesture: {
                            key: ej2_diagrams_1.Keys.C, keyModifiers: ej2_diagrams_1.KeyModifiers.Control
                        }
                    },
                    {
                        name: "cut",
                        canExecute: () => {
                            return that.Mode === WfMode.Edit && (that.m_diagram.selectedItems.connectors.length > 0 || that.m_diagram.selectedItems.nodes.length > 0);
                        },
                        execute: () => {
                            that.m_pasteCounter = 0;
                            let wfElemens = new Array();
                            that.m_ignoreHistoryChange = true;
                            let elementsToRemove = new Array();
                            for (let node of that.m_diagram.selectedItems.nodes) {
                                let nodeId = node.addInfo["wfelemid"];
                                wfElemens.push(that.getWfNodeById(nodeId).clone());
                                elementsToRemove.push(node);
                            }
                            for (let connector of that.m_diagram.selectedItems.connectors) {
                                let connectorId = connector.addInfo["wfelemid"];
                                let connectorToCopy = Object.assign(new WorkflowModel_1.WfConnector(), that.getWfConnectorById(connectorId));
                                if (connectorToCopy.SourceNodeId && wfElemens.findIndex(item => item.Id === connectorToCopy.SourceNodeId) == -1) {
                                    connectorToCopy.SourceNodeId = undefined;
                                    connectorToCopy.SourcePortId = undefined;
                                }
                                if (connectorToCopy.TargetNodeId && wfElemens.findIndex(item => item.Id === connectorToCopy.TargetNodeId) == -1) {
                                    connectorToCopy.TargetNodeId = undefined;
                                    connectorToCopy.TargetPortId = undefined;
                                }
                                wfElemens.push(connectorToCopy);
                                elementsToRemove.unshift(connector);
                            }
                            for (let elem of elementsToRemove)
                                that.m_diagram.remove(elem);
                            SessionStorageManager_1.SessionStorageManager.setItem(SessionStorageManager_1.SessionStorageType.WF_Clipboard, "copiedItems", wfElemens);
                            that.m_ignoreHistoryChange = false;
                            that.addHistoryObject();
                            Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("wf_cut_notification"));
                        },
                        gesture: {
                            key: ej2_diagrams_1.Keys.X, keyModifiers: ej2_diagrams_1.KeyModifiers.Control
                        }
                    },
                    {
                        name: "paste",
                        canExecute: () => {
                            return that.Mode === WfMode.Edit;
                        },
                        execute: () => {
                            that.m_pasteCounter += 1;
                            let objectsToSelect = new Array();
                            let copiedItems = SessionStorageManager_1.SessionStorageManager.getItem(SessionStorageManager_1.SessionStorageType.WF_Clipboard, "copiedItems");
                            //Check if paste is allowed
                            let pasteIsAllowed = true;
                            if (that.m_levelOfDetail === WfDetailLevel.Detailed) {
                                for (let copiedItem of copiedItems)
                                    if (copiedItem.$type === "At.Technodat.Workflow.ViewNode, TdWorkflow")
                                        pasteIsAllowed = false;
                            }
                            else {
                                for (let copiedItem of copiedItems)
                                    if (copiedItem.$type != "At.Technodat.Workflow.ViewNode, TdWorkflow")
                                        pasteIsAllowed = false;
                            }
                            if (!pasteIsAllowed)
                                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("wf_paste_not_allowed_notification"));
                            else {
                                let modifiedIdMap = [];
                                for (let copiedItem of copiedItems) {
                                    let newId = WorkflowModel_1.WorkflowModel.getNewElementId();
                                    modifiedIdMap.push({ oldId: copiedItem.Id, newId: newId });
                                    copiedItem.Id = newId;
                                    if (copiedItem.$type === "WfConnector") {
                                        let connector = Object.assign(new WorkflowModel_1.WfConnector(), copiedItem);
                                        if (connector.SourceNodeId) {
                                            let modifiedIdEntry = modifiedIdMap.find(entry => entry["oldId"] === connector.SourceNodeId);
                                            if (modifiedIdEntry)
                                                connector.SourceNodeId = modifiedIdEntry["newId"];
                                        }
                                        else {
                                            connector.SourcePointPosX += (that.m_pasteCounter * 10);
                                            connector.SourcePointPosY += (that.m_pasteCounter * 10);
                                        }
                                        if (connector.TargetNodeId) {
                                            let modifiedIdEntry = modifiedIdMap.find(entry => entry["oldId"] === connector.TargetNodeId);
                                            if (modifiedIdEntry)
                                                connector.TargetNodeId = modifiedIdEntry["newId"];
                                        }
                                        else {
                                            connector.TargetPointPosX += (that.m_pasteCounter * 10);
                                            connector.TargetPointPosY += (that.m_pasteCounter * 10);
                                        }
                                        let addedConnector = that.addWfConnector(connector);
                                        that.m_workflowModel.ConnectorList.push(connector);
                                        objectsToSelect.push(addedConnector);
                                    }
                                    else {
                                        let node;
                                        switch (copiedItem.$type) {
                                            case "At.Technodat.Workflow.StartNode, TdWorkflow":
                                                node = WorkflowModel_1.StartNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.EndNode, TdWorkflow":
                                                node = WorkflowModel_1.EndNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.ActivityNode, TdWorkflow":
                                                node = WorkflowModel_1.ActivityNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.ForkNode, TdWorkflow":
                                                node = WorkflowModel_1.ForkNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.WaitNode, TdWorkflow":
                                                node = WorkflowModel_1.WaitNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.DynamicForkNode, TdWorkflow":
                                                node = WorkflowModel_1.DynamicForkNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.DynamicWaitNode, TdWorkflow":
                                                node = WorkflowModel_1.DynamicWaitNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.ViewNode, TdWorkflow":
                                                node = WorkflowModel_1.ViewNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.GuiNode, TdWorkflow":
                                                node = WorkflowModel_1.GuiNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.TextBoxNode, TdWorkflow":
                                                node = WorkflowModel_1.WfTextBoxNode.fromJSON(copiedItem);
                                                break;
                                            case "At.Technodat.Workflow.TextLabelNode, TdWorkflow":
                                                node = WorkflowModel_1.WfTextLabelNode.fromJSON(copiedItem);
                                                break;
                                        }
                                        if (node) {
                                            node.PosX += (that.m_pasteCounter * 10);
                                            node.PosY += (that.m_pasteCounter * 10);
                                            that.m_workflowModel.NodeList.push(node);
                                            let addedNode = that.addWfNode(node);
                                            if (addedNode)
                                                objectsToSelect.push(addedNode);
                                        }
                                    }
                                }
                                if (objectsToSelect.length > 0)
                                    that.m_diagram.select(objectsToSelect);
                                that.addHistoryObject();
                                Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("wf_paste_notification"));
                            }
                        },
                        gesture: {
                            key: ej2_diagrams_1.Keys.V, keyModifiers: ej2_diagrams_1.KeyModifiers.Control
                        }
                    },
                    {
                        name: "undo",
                        canExecute: () => {
                            return !that.m_historyIsChanging && that.Mode === WfMode.Edit && that.m_historyStack.length > 1 && that.m_historyStackPosition > 0;
                        },
                        execute: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            if (!that.m_historyIsChanging) {
                                that.m_historyIsChanging = true;
                                that.m_historyStackPosition -= 1;
                                if (that.m_historyStackPosition === 0) {
                                    that.m_workFlowModelHasChanged = false;
                                    that.m_$saveButton.attr("disabled", "disabled").addClass("k-state-disabled");
                                }
                                //Needed for segment changes and alignment, because there are no events we can wait for                                
                                let selItemIds = [];
                                for (let elem of that.m_diagram.selectedItems.nodes) {
                                    selItemIds.push(elem.addInfo["wfelemid"]);
                                }
                                for (let elem of that.m_diagram.selectedItems.connectors) {
                                    selItemIds.push(elem.addInfo["wfelemid"]);
                                }
                                let wf = that.m_workflowModel;
                                that.updatePositions(wf);
                                that.updateSegments(wf);
                                that.m_historyStack[that.m_historyStackPosition + 1] = new HistoryObject(wf.clone(), selItemIds, that.m_levelOfDetail);
                                let historyObject = that.m_historyStack[that.m_historyStackPosition];
                                let newWorkflow = historyObject.Worklow.clone();
                                that.m_ignoreHistoryChange = true;
                                that.updateDiagram(newWorkflow);
                                that.m_workflowModel = newWorkflow;
                                let selItems = new Array();
                                for (let id of historyObject.SelectedItemIds) {
                                    let obj = that.getDiagramObjectById(id);
                                    if (obj instanceof ej2_diagrams_1.Node || obj instanceof ej2_diagrams_1.Connector)
                                        selItems.push(obj);
                                }
                                that.m_diagram.select(selItems);
                                yield that.updateSelection();
                                that.search();
                                that.m_ignoreHistoryChange = false;
                                Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("wf_undo_notification"));
                                this.m_$redoButton.removeAttr("disabled").removeClass("k-state-disabled");
                                if (that.m_historyStackPosition === 0)
                                    this.m_$undoButton.attr("disabled", "disabled").addClass("k-state-disabled");
                                that.m_historyIsChanging = false;
                            }
                        }),
                        gesture: {
                            key: ej2_diagrams_1.Keys.Z, keyModifiers: ej2_diagrams_1.KeyModifiers.Control
                        }
                    },
                    {
                        name: "redo",
                        canExecute: () => {
                            return !that.m_historyIsChanging && that.Mode === WfMode.Edit && that.m_historyStack.length > 1 && that.m_historyStackPosition != that.m_historyStack.length - 1;
                        },
                        execute: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            if (!that.m_historyIsChanging) {
                                that.m_historyIsChanging = true;
                                that.m_historyStackPosition += 1;
                                let HistoryObject = that.m_historyStack[that.m_historyStackPosition];
                                let newWorkflow = HistoryObject.Worklow.clone();
                                that.m_ignoreHistoryChange = true;
                                that.updateDiagram(newWorkflow);
                                that.m_workflowModel = newWorkflow;
                                let selItems = new Array();
                                for (let id of HistoryObject.SelectedItemIds) {
                                    let obj = that.getDiagramObjectById(id);
                                    if (obj instanceof ej2_diagrams_1.Node || obj instanceof ej2_diagrams_1.Connector)
                                        selItems.push(obj);
                                }
                                that.m_diagram.select(selItems);
                                yield that.updateSelection();
                                that.search();
                                that.m_ignoreHistoryChange = false;
                                Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("wf_redo_notification"));
                                this.m_$undoButton.removeAttr("disabled").removeClass("k-state-disabled");
                                if (that.m_historyStackPosition === that.m_historyStack.length - 1)
                                    this.m_$redoButton.attr("disabled", "disabled").addClass("k-state-disabled");
                                that.m_historyIsChanging = false;
                            }
                        }),
                        gesture: {
                            key: ej2_diagrams_1.Keys.Y, keyModifiers: ej2_diagrams_1.KeyModifiers.Control
                        }
                    },
                ]
            },
            connectionChange: (e) => {
                if (e.state === "Changed") {
                    let wfConnector = that.getWfConnectorById(e.connector.addInfo["wfelemid"]);
                    if (e.connectorEnd === "ConnectorTargetEnd") {
                        wfConnector.TargetNodeId = e.newValue["nodeId"];
                        wfConnector.TargetPortId = e.newValue["portID"];
                    }
                    else if (e.connectorEnd === "ConnectorSourceEnd") {
                        wfConnector.SourceNodeId = e.newValue["nodeId"];
                        wfConnector.SourcePortId = e.newValue["portID"];
                    }
                    else {
                        wfConnector.TargetNodeId = e.newValue["targetID"];
                        wfConnector.TargetPortId = e.newValue["targetPortID"];
                        wfConnector.SourceNodeId = e.newValue["sourceID"];
                        wfConnector.SourcePortId = e.newValue["sourcePortID"];
                    }
                    wfConnector.SourcePointPosX = e.connector.sourcePoint.x;
                    wfConnector.SourcePointPosY = e.connector.sourcePoint.y;
                    wfConnector.TargetPointPosX = e.connector.targetPoint.x;
                    wfConnector.TargetPointPosY = e.connector.targetPoint.y;
                }
            },
            propertyChange: (e) => {
                if (e.element instanceof ej2_diagrams_1.Connector && this.m_mode == WfMode.Edit) {
                    let connector = that.m_workflowModel.ConnectorList.find(c => c.Id === e.element.addInfo["wfelemid"]);
                    if (connector)
                        connector.SetNewEtag();
                    this.updateSegments(this.m_workflowModel);
                    // If connector has changed, mark workflow model as changed and save enable buttons
                    this.m_workFlowModelHasChanged = true;
                    this.m_$saveButton.removeAttr("disabled").removeClass("k-state-disabled");
                }
            },
            textEdit: (e) => {
                if (e && that.m_diagram.selectedItems) {
                    for (let node of that.m_diagram.selectedItems.nodes) {
                        let selectedNode = that.m_workflowModel.NodeList.find(n => n.Id === node.addInfo["wfelemid"]);
                        if (selectedNode) {
                            selectedNode.Description = e.newValue;
                            if (node.addInfo["wftype"] === "Node")
                                that.checkPropertyChange(node.addInfo["wfelemid"], node.addInfo["wfelemid"], "Node", "Description", e.newValue);
                            else
                                that.checkPropertyChange(node.addInfo["wfelemid"], node.addInfo["wfelemid"], "WfTextNode", "Description", e.newValue);
                            selectedNode.SetNewEtag();
                        }
                    }
                    ;
                    for (let conncector of that.m_diagram.selectedItems.connectors) {
                        let selectedConnector = that.m_workflowModel.ConnectorList.find(c => c.Id === conncector.addInfo["wfelemid"]);
                        if (selectedConnector) {
                            selectedConnector.Description = e.newValue;
                            that.checkPropertyChange(conncector.addInfo["wfelemid"], conncector.addInfo["wfelemid"], "Connector", "Description", e.newValue);
                            selectedConnector.SetNewEtag();
                        }
                    }
                    that.addHistoryObject();
                }
            },
            click: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (that.m_colorPickerFill)
                    that.m_colorPickerFill.close(); // Fix for IE11
                if (that.m_colorPickerText)
                    that.m_colorPickerText.close(); // Fix for IE11
                yield that.updateSelection();
            }),
            drop: (e) => {
                if (e) {
                    if (e.element instanceof ej2_diagrams_1.Node) {
                        let currentNode = e.element;
                        let isViewNode = false;
                        if (e.source && e.source instanceof ej2_diagrams_1.SymbolPalette) {
                            if (currentNode.addInfo["wftype"] === "Node") {
                                let node;
                                let visualObject;
                                switch (currentNode.data.shapeId) {
                                    case WorkflowShapeId[WorkflowShapeId.Activity]:
                                        node = new WorkflowModel_1.ActivityNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.Start]:
                                        node = new WorkflowModel_1.StartNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.End]:
                                        node = new WorkflowModel_1.EndNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.Fork]:
                                        node = new WorkflowModel_1.ForkNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.Wait]:
                                        node = new WorkflowModel_1.WaitNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.DynamicFork]:
                                        node = new WorkflowModel_1.DynamicForkNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.DynamicWait]:
                                        node = new WorkflowModel_1.DynamicWaitNode();
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.View]:
                                        node = new WorkflowModel_1.ViewNode();
                                        isViewNode = true;
                                        break;
                                    case WorkflowShapeId[WorkflowShapeId.Gui]:
                                        node = new WorkflowModel_1.GuiNode();
                                        break;
                                }
                                node.Id = WorkflowModel_1.WorkflowModel.getNewElementId();
                                node.PosX = currentNode.offsetX;
                                node.PosY = currentNode.offsetY;
                                node.Width = currentNode.width;
                                node.Height = currentNode.height;
                                node.Description = currentNode.annotations[0].content;
                                //Add new node
                                that.m_workflowModel.NodeList.push(node);
                                e.cancel = true;
                                that.addWfNode(node);
                                currentNode = that.getDiagramObjectById(node.Id);
                            }
                            else {
                                let visualObject;
                                switch (currentNode.data.shapeId) {
                                    case VisualShapeId[VisualShapeId.Rectangle]:
                                        visualObject = new WorkflowModel_1.WfTextBoxNode();
                                        break;
                                    case VisualShapeId[VisualShapeId.Text]:
                                        visualObject = new WorkflowModel_1.WfTextLabelNode();
                                        break;
                                }
                                visualObject.Id = WorkflowModel_1.WorkflowModel.getNewElementId();
                                visualObject.PosX = currentNode.offsetX;
                                visualObject.PosY = currentNode.offsetY;
                                visualObject.Width = currentNode.width;
                                visualObject.Height = currentNode.height;
                                if (currentNode.annotations && currentNode.annotations.length > 0)
                                    visualObject.Description = currentNode.annotations[0].content;
                                //Add new node
                                that.m_workflowModel.NodeList.push(visualObject);
                                e.cancel = true;
                                that.addWfNode(visualObject);
                                currentNode = that.getDiagramObjectById(visualObject.Id);
                            }
                        }
                        that.m_diagram.dataBind();
                        if (e.target && currentNode.addInfo["wftype"] === "Node" && !isViewNode) {
                            let foundConnector;
                            if (e.target instanceof ej2_diagrams_1.Node) {
                                let x1 = currentNode.offsetX - currentNode.width / 2;
                                let x2 = currentNode.offsetX + currentNode.width / 2;
                                let y1 = currentNode.offsetY - currentNode.height / 2;
                                let y2 = currentNode.offsetY + currentNode.height / 2;
                                if (that.m_diagram.connectors) {
                                    let connectorFound = false;
                                    for (let connector of that.m_diagram.connectors) {
                                        if (connector instanceof ej2_diagrams_1.Connector) {
                                            let nodeIsOverConector = false;
                                            if (!connectorFound) {
                                                for (let i = 0; i < connector.intermediatePoints.length - 1; ++i) {
                                                    let startPoint = connector.intermediatePoints[i];
                                                    let endPoint = connector.intermediatePoints[i + 1];
                                                    if (!(startPoint.x === endPoint.x && startPoint.y === endPoint.y)) {
                                                        if (((startPoint.x >= x1 && startPoint.x <= x2) && (startPoint.y >= y1 && startPoint.y <= y2)) ||
                                                            ((endPoint.x >= x1 && endPoint.x <= x2) && (endPoint.y >= y1 && endPoint.y <= y2)))
                                                            nodeIsOverConector = true;
                                                        else {
                                                            if (startPoint.x == endPoint.x) {
                                                                //vertical
                                                                if ((startPoint.x >= x1 && startPoint.x <= x2) &&
                                                                    ((y1 >= startPoint.y && y1 <= endPoint.y) ||
                                                                        ((y2 >= startPoint.y && y2 <= endPoint.y))))
                                                                    nodeIsOverConector = true;
                                                            }
                                                            else {
                                                                //horizontal
                                                                if ((startPoint.y >= y1 && startPoint.y <= y2) &&
                                                                    ((x1 >= startPoint.x && x1 <= endPoint.x) ||
                                                                        ((x2 >= startPoint.x && x2 <= endPoint.x))))
                                                                    nodeIsOverConector = true;
                                                            }
                                                        }
                                                        if (nodeIsOverConector) {
                                                            foundConnector = connector;
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else if (e.target instanceof ej2_diagrams_1.Connector) {
                                foundConnector = e.target;
                            }
                            if (foundConnector) {
                                let nextNode;
                                let beforeNode;
                                if (foundConnector.targetID && foundConnector.sourceID) {
                                    //place in between
                                    let targetId = foundConnector.targetID;
                                    let wfConnector = new WorkflowModel_1.WfConnector();
                                    wfConnector.Id = WorkflowModel_1.WorkflowModel.getNewElementId();
                                    wfConnector.SourceNodeId = currentNode.addInfo["wfelemid"];
                                    wfConnector.TargetNodeId = that.getWfNodeByConvertId(targetId).Id;
                                    that.addWfConnector(wfConnector);
                                    that.m_workflowModel.ConnectorList.push(wfConnector);
                                    foundConnector.targetID = currentNode.id;
                                    that.m_diagram.dataBind();
                                    let wfFoundConnector = that.getWfConnectorById(foundConnector.addInfo["wfelemid"]);
                                    wfFoundConnector.TargetNodeId = currentNode.addInfo["wfelemid"];
                                    wfFoundConnector.SetNewEtag();
                                    wfConnector.TargetPointPosX = foundConnector.targetPoint.x;
                                    wfConnector.TargetPointPosY = foundConnector.targetPoint.y;
                                    nextNode = that.m_diagram.getObject(targetId);
                                    beforeNode = that.m_diagram.getObject(foundConnector.sourceID);
                                    if (Math.abs(nextNode.offsetX - beforeNode.offsetX) < 5) {
                                        currentNode.offsetX = nextNode.offsetX;
                                    }
                                    else if (Math.abs(nextNode.offsetY - beforeNode.offsetY) < 5) {
                                        currentNode.offsetY = nextNode.offsetY;
                                    }
                                    else {
                                        if (Math.abs(beforeNode.offsetX - currentNode.offsetX) < Math.abs(nextNode.offsetX - currentNode.offsetX)) {
                                            currentNode.offsetX = beforeNode.offsetX;
                                            currentNode.offsetY = nextNode.offsetY;
                                        }
                                        else {
                                            currentNode.offsetX = nextNode.offsetX;
                                            currentNode.offsetY = beforeNode.offsetY;
                                        }
                                    }
                                    let wfNode = that.getWfNodeById(currentNode.addInfo["wfelemid"]);
                                    wfNode.PosX = currentNode.offsetX;
                                    wfNode.PosY = currentNode.offsetY;
                                    that.m_diagram.dataBind();
                                }
                                else if (foundConnector.sourceID) {
                                    let oldx = foundConnector.targetPoint.x;
                                    let oldy = foundConnector.targetPoint.y;
                                    foundConnector.targetID = currentNode.id;
                                    that.m_diagram.dataBind();
                                    let wfConnector = that.getWfConnectorById(foundConnector.addInfo["wfelemid"]);
                                    wfConnector.TargetNodeId = currentNode.addInfo["wfelemid"];
                                    wfConnector.SetNewEtag();
                                    beforeNode = that.m_diagram.getObject(foundConnector.sourceID);
                                }
                                else {
                                    let oldx = foundConnector.sourcePoint.x;
                                    let oldy = foundConnector.sourcePoint.y;
                                    foundConnector.sourceID = currentNode.id;
                                    that.m_diagram.dataBind();
                                    let wfConnector = that.getWfConnectorById(foundConnector.addInfo["wfelemid"]);
                                    wfConnector.TargetNodeId = currentNode.addInfo["wfelemid"];
                                    wfConnector.SetNewEtag();
                                    nextNode = that.m_diagram.getObject(foundConnector.targetID);
                                }
                                //Check if overlaps
                                let nodeLeft = currentNode.offsetX - currentNode.width / 2;
                                let nodeRight = currentNode.offsetX + currentNode.width / 2;
                                let nodeTop = currentNode.offsetY - currentNode.height / 2;
                                let nodeBottom = currentNode.offsetY + currentNode.height / 2;
                                let nodeRect = new ej2_diagrams_1.Rect(nodeLeft, nodeTop, currentNode.width, currentNode.height);
                                if (nextNode) {
                                    let left = nextNode.offsetX - nextNode.width / 2;
                                    let top = nextNode.offsetY - nextNode.height / 2;
                                    let intersect = that.rectangleIntersect(nodeRect, new ej2_diagrams_1.Rect(left, top, nextNode.width, nextNode.height));
                                    if (intersect) {
                                        if (Math.abs(nextNode.offsetX - currentNode.offsetX) > Math.abs(nextNode.offsetY - currentNode.offsetY)) {
                                            // move elements to right                        
                                            let offset = Math.abs(nodeRight - left) + 50;
                                            for (let nodeToMove of that.m_diagram.nodes) {
                                                if (nodeToMove.id != currentNode.id) {
                                                    let nodeToMoveLeft = nodeToMove.offsetX - nodeToMove.width / 2;
                                                    if (nodeToMoveLeft > nodeLeft) {
                                                        nodeToMove.offsetX += offset;
                                                        //update wfconnector
                                                        let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                        tmpNode.PosX = nodeToMove.offsetX;
                                                        tmpNode.SetNewEtag();
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            // move things down
                                            let offset = Math.abs(nodeBottom - top) + 50;
                                            for (let nodeToMove of that.m_diagram.nodes) {
                                                if (nodeToMove.id != currentNode.id) {
                                                    let nodeToMoveTop = nodeToMove.offsetY - nodeToMove.height / 2;
                                                    if (nodeToMoveTop > nodeTop) {
                                                        nodeToMove.offsetY += offset;
                                                        //update wfconnector
                                                        let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                        tmpNode.PosY = nodeToMove.offsetY;
                                                        tmpNode.SetNewEtag();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        if (Math.abs(nextNode.offsetX - currentNode.offsetX) > Math.abs(nextNode.offsetY - currentNode.offsetY)) {
                                            //Check if distance is greater than 50
                                            if (Math.abs(nodeRight - left) < 50) {
                                                // move elements to right                        
                                                let offset = 50 - Math.abs(nodeRight - left);
                                                for (let nodeToMove of that.m_diagram.nodes) {
                                                    if (nodeToMove.id != currentNode.id) {
                                                        let nodeToMoveLeft = nodeToMove.offsetX - nodeToMove.width / 2;
                                                        if (nodeToMoveLeft > nodeLeft) {
                                                            nodeToMove.offsetX += offset;
                                                            //update wfconnector
                                                            let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                            tmpNode.PosX = nodeToMove.offsetX;
                                                            tmpNode.SetNewEtag();
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            //Check if distance is greater than 50
                                            if (Math.abs(nodeBottom - top) < 50) {
                                                // move things down
                                                let offset = 50 - Math.abs(nodeBottom - top);
                                                for (let nodeToMove of that.m_diagram.nodes) {
                                                    if (nodeToMove.id != currentNode.id) {
                                                        let nodeToMoveTop = nodeToMove.offsetY - nodeToMove.height / 2;
                                                        if (nodeToMoveTop > nodeTop) {
                                                            nodeToMove.offsetY += offset;
                                                            //update wfconnector
                                                            let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                            tmpNode.PosY = nodeToMove.offsetY;
                                                            tmpNode.SetNewEtag();
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    that.m_diagram.dataBind();
                                }
                                if (beforeNode) {
                                    let left = beforeNode.offsetX - beforeNode.width / 2;
                                    let right = beforeNode.offsetX + beforeNode.width / 2;
                                    let top = beforeNode.offsetY - beforeNode.height / 2;
                                    let bottom = beforeNode.offsetY + beforeNode.height / 2;
                                    let intersect = that.rectangleIntersect(nodeRect, new ej2_diagrams_1.Rect(left, top, beforeNode.width, beforeNode.height));
                                    if (intersect) {
                                        if (Math.abs(beforeNode.offsetX - currentNode.offsetX) > Math.abs(beforeNode.offsetY - currentNode.offsetY)) {
                                            // move elements to right
                                            let offset = Math.abs(right - nodeLeft) + 50;
                                            for (let nodeToMove of that.m_diagram.nodes) {
                                                let nodeToMoveLeft = nodeToMove.offsetX - nodeToMove.width / 2;
                                                if (nodeToMoveLeft > left) {
                                                    nodeToMove.offsetX += offset;
                                                    //update wfconnector
                                                    let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                    tmpNode.PosX = nodeToMove.offsetX;
                                                    tmpNode.SetNewEtag();
                                                }
                                            }
                                        }
                                        else {
                                            // move things down
                                            let offset = Math.abs(bottom - nodeTop) + 50;
                                            for (let nodeToMove of that.m_diagram.nodes) {
                                                let nodeToMoveTop = nodeToMove.offsetY - nodeToMove.height / 2;
                                                if (nodeToMoveTop > top) {
                                                    nodeToMove.offsetY += offset;
                                                    //update wfconnector
                                                    let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                    tmpNode.PosY = nodeToMove.offsetY;
                                                    tmpNode.SetNewEtag();
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        if (Math.abs(beforeNode.offsetX - currentNode.offsetX) > Math.abs(beforeNode.offsetY - currentNode.offsetY)) {
                                            //Check if distance is greater than 50
                                            if (Math.abs(right - nodeLeft) < 50) {
                                                // move elements to right
                                                let offset = 50 - Math.abs(right - nodeLeft);
                                                for (let nodeToMove of that.m_diagram.nodes) {
                                                    let nodeToMoveLeft = nodeToMove.offsetX - nodeToMove.width / 2;
                                                    if (nodeToMoveLeft > left) {
                                                        nodeToMove.offsetX += offset;
                                                        //update wfconnector
                                                        let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                        tmpNode.PosX = nodeToMove.offsetX;
                                                        tmpNode.SetNewEtag();
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            //Check if distance is greater than 50
                                            if (Math.abs(bottom - nodeTop) < 50) {
                                                // move things down
                                                let offset = 50 - Math.abs(bottom - nodeTop);
                                                for (let nodeToMove of that.m_diagram.nodes) {
                                                    let nodeToMoveTop = nodeToMove.offsetY - nodeToMove.height / 2;
                                                    if (nodeToMoveTop > top) {
                                                        nodeToMove.offsetY += offset;
                                                        //update wfconnector
                                                        let tmpNode = that.getWfNodeById(nodeToMove.addInfo["wfelemid"]);
                                                        tmpNode.PosY = nodeToMove.offsetY;
                                                        tmpNode.SetNewEtag();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    that.m_diagram.dataBind();
                                }
                            }
                        }
                        that.addHistoryObject();
                        that.m_diagram.select([currentNode]);
                        that.updateSelection();
                    }
                    else if (e.element instanceof ej2_diagrams_1.Connector) {
                        let obj = e.element;
                        this.setConnectorConstraints(obj);
                        let connector = new WorkflowModel_1.WfConnector();
                        connector.Id = obj.addInfo["wfelemid"];
                        connector.SourcePointPosX = obj.sourcePoint.x;
                        connector.SourcePointPosY = obj.sourcePoint.y;
                        connector.TargetPointPosX = obj.targetPoint.x;
                        connector.TargetPointPosY = obj.targetPoint.y;
                        //Add new connector
                        that.m_workflowModel.ConnectorList.push(connector);
                        that.addHistoryObject();
                        that.m_diagram.select([obj]);
                        that.updateSelection();
                    }
                }
            },
            collectionChange: (e) => {
                if (e.state === "Changed" && !this.m_ignoreModelManipulation) {
                    if (e.type === "Removal") {
                        if (e.element instanceof ej2_diagrams_1.Node) {
                            let idxToDelete = that.m_workflowModel.NodeList.findIndex(node => node.Id === e.element.addInfo["wfelemid"]);
                            if (idxToDelete != -1)
                                that.m_workflowModel.NodeList.splice(idxToDelete, 1);
                        }
                        else if (e.element instanceof ej2_diagrams_1.Connector) {
                            let idxToDelete = that.m_workflowModel.ConnectorList.findIndex(connector => connector.Id === e.element.addInfo["wfelemid"]);
                            if (idxToDelete != -1)
                                that.m_workflowModel.ConnectorList.splice(idxToDelete, 1);
                        }
                        that.addHistoryObject();
                    }
                    else if (e.type === "Addition") {
                        if (e.element instanceof ej2_diagrams_1.Node) {
                            if (e.element.addInfo["wftype"] === "Node") {
                                e.element.constraints = e.element.constraints & ~(ej2_diagrams_1.NodeConstraints.Rotate);
                                e.element.constraints |= ej2_diagrams_1.NodeConstraints.AspectRatio;
                                e.element.constraints = e.element.constraints & ~(ej2_diagrams_1.NodeConstraints.AllowDrop);
                            }
                            else {
                                let node = e.element;
                                let wfTextNode = that.getWfNodeById(node.addInfo["wfelemid"]);
                                if (!wfTextNode) {
                                    if (node.addInfo["wftype"] === "TextLabelNode")
                                        wfTextNode = new WorkflowModel_1.WfTextLabelNode();
                                    else if (node.addInfo["wftype"] === "TextBoxNode")
                                        wfTextNode = new WorkflowModel_1.WfTextBoxNode();
                                    if (wfTextNode) {
                                        if (node.annotations && node.annotations.length > 0)
                                            wfTextNode.Description = node.annotations[0].content;
                                        wfTextNode.Id = node.addInfo["wfelemid"];
                                        wfTextNode.PosX = node.offsetX;
                                        wfTextNode.PosY = node.offsetY;
                                        wfTextNode.Width = node.width;
                                        wfTextNode.Height = node.height;
                                        //Add new visual element
                                        that.m_workflowModel.NodeList.push(wfTextNode);
                                        that.addHistoryObject();
                                    }
                                }
                            }
                        }
                        else if (e.element instanceof ej2_diagrams_1.Connector) {
                            let connector = e.element;
                            let wfConnector = that.getWfConnectorById(connector.addInfo["wfelemid"]);
                            if (!wfConnector) {
                                wfConnector = new WorkflowModel_1.WfConnector();
                                wfConnector.Id = connector.addInfo["wfelemid"];
                                wfConnector.SourcePointPosX = connector.sourcePoint.x;
                                wfConnector.SourcePointPosY = connector.sourcePoint.y;
                                wfConnector.TargetPointPosX = connector.targetPoint.x;
                                wfConnector.TargetPointPosY = connector.targetPoint.y;
                                if (connector.sourceID) {
                                    wfConnector.SourceNodeId = that.getWfNodeByConvertId(connector.sourceID).Id;
                                    wfConnector.SourcePortId = connector.sourcePortID;
                                }
                                if (connector.targetID) {
                                    wfConnector.TargetNodeId = that.getWfNodeByConvertId(connector.targetID).Id;
                                    wfConnector.TargetPortId = connector.targetPortID;
                                }
                                //Add new connector
                                that.m_workflowModel.ConnectorList.push(wfConnector);
                                that.addHistoryObject();
                            }
                        }
                    }
                }
                // Check for duplicate syneris ids (Happens on copy & paste)
                let seenSynerisIds = [];
                for (let node of that.m_diagram.nodes) {
                    if (node.data && node.data["id"]) {
                        let synerisId = node.data["id"];
                        if (seenSynerisIds.indexOf(synerisId) !== -1) {
                            node.data["id"] = undefined;
                        }
                        else {
                            seenSynerisIds.push(synerisId);
                        }
                    }
                }
            },
            positionChange: (e) => {
                if (e.state == "Completed") {
                    let updateNodePositionChange = (node) => {
                        let wfNode = that.getWfNodeById(node.addInfo["wfelemid"]);
                        if (wfNode) {
                            wfNode.PosX = node.offsetX;
                            wfNode.PosY = node.offsetY;
                            wfNode.SetNewEtag();
                        }
                    };
                    let updateConnectorPositionChange = (connector) => {
                        let wfConnector = that.getWfConnectorById(connector.addInfo["wfelemid"]);
                        if (wfConnector) {
                            wfConnector.SourcePointPosX = connector.sourcePoint.x;
                            wfConnector.SourcePointPosY = connector.sourcePoint.y;
                            wfConnector.TargetPointPosX = connector.targetPoint.x;
                            wfConnector.TargetPointPosY = connector.targetPoint.y;
                            wfConnector.SetNewEtag();
                        }
                    };
                    if (e.source instanceof ej2_diagrams_1.Selector) {
                        for (let node of e.source.nodes) {
                            updateNodePositionChange(node);
                        }
                        for (let connector of e.source.connectors)
                            updateConnectorPositionChange(connector);
                    }
                    else if (e.source instanceof ej2_diagrams_1.Node)
                        updateNodePositionChange(e.source);
                    else if (e.source instanceof ej2_diagrams_1.Connector)
                        updateConnectorPositionChange(e.source);
                    if (!e.target)
                        that.addHistoryObject();
                }
            },
            sizeChange: (e) => {
                if (e.state === "Completed") {
                    let updateNodeSizeChange = (node) => {
                        let wfNode = that.getWfNodeById(node.addInfo["wfelemid"]);
                        if (wfNode) {
                            wfNode.Width = node.width;
                            wfNode.Height = node.height;
                            wfNode.PosX = node.offsetX;
                            wfNode.PosY = node.offsetY;
                            wfNode.SetNewEtag();
                        }
                    };
                    if (e.source instanceof ej2_diagrams_1.Selector) {
                        if (e.source.nodes.length > 0) {
                            for (let node of e.source.nodes)
                                updateNodeSizeChange(node);
                            that.addHistoryObject();
                        }
                    }
                    else if (e.source instanceof ej2_diagrams_1.Node) {
                        let node = e.source;
                        if (node.addInfo["wftype"] === "Node")
                            updateNodeSizeChange(node);
                        that.addHistoryObject();
                    }
                }
            },
            sourcePointChange: (e) => {
                if (e.state == "Completed") {
                    let wfConnector = that.getWfConnectorById(e.connector.addInfo["wfelemid"]);
                    if (e.connector.sourceID) {
                        wfConnector.SourceNodeId = that.getWfNodeByConvertId(e.connector.sourceID).Id;
                        wfConnector.SourcePortId = e.connector.sourcePortID;
                    }
                    else {
                        wfConnector.SourceNodeId = undefined;
                        wfConnector.SourcePortId = undefined;
                    }
                    wfConnector.SourcePointPosX = e.connector.sourcePoint.x;
                    wfConnector.SourcePointPosY = e.connector.sourcePoint.y;
                    wfConnector.SetNewEtag();
                    that.addHistoryObject();
                }
            },
            targetPointChange: (e) => {
                if (e.state == "Completed") {
                    let wfConnector = that.getWfConnectorById(e.connector.addInfo["wfelemid"]);
                    if (e.connector.targetID) {
                        wfConnector.TargetNodeId = that.getWfNodeByConvertId(e.connector.targetID).Id;
                        wfConnector.TargetPortId = e.connector.targetPortID;
                    }
                    else {
                        wfConnector.TargetNodeId = undefined;
                        wfConnector.TargetPortId = undefined;
                    }
                    wfConnector.TargetPointPosX = e.connector.targetPoint.x;
                    wfConnector.TargetPointPosY = e.connector.targetPoint.y;
                    wfConnector.SetNewEtag();
                    that.addHistoryObject();
                }
            },
        });
        that.m_diagram.appendTo(pMD[0]);
        $("#" + diagramId + "content").css("outline", "none");
        if (that.Mode === WfMode.Edit)
            that.createPalette();
        if (!that.m_typeNames) {
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("WorkflowGetWorkflowTypeNames"),
                done: (typeNames) => {
                    that.m_typeNames = typeNames;
                },
            });
        }
        if (!that.m_forPreview) {
            that.m_$propertiesContainer.empty();
            that.m_$properties.off("mouseover").on("mouseover", ".wfTextArea", (e) => {
                let computed = window.getComputedStyle(e.currentTarget);
                let height = parseInt(computed.getPropertyValue("border-top-width"), 10)
                    + e.currentTarget.scrollHeight
                    + parseInt(computed.getPropertyValue("border-bottom-width"), 10);
                e.currentTarget.style.height = height + "px";
            });
            that.m_$properties.off("input").on("input", ".wfTextArea", (e) => {
                let computed = window.getComputedStyle(e.currentTarget);
                let height = parseInt(computed.getPropertyValue("border-top-width"), 10)
                    + e.currentTarget.scrollHeight
                    + parseInt(computed.getPropertyValue("border-bottom-width"), 10);
                e.currentTarget.style.height = height + "px";
            });
            that.m_$properties.off("mouseout").on("mouseout", ".wfTextArea", (e) => {
                e.currentTarget.style.height = "auto";
            });
        }
    }
    convertId(id) {
        if (id)
            return "Elem" + id.substring(1, id.length - 1).split("-").join("");
        return id;
    }
    setDiagramNodeData(diagramNode, node) {
        let newId = this.convertId(node.Id);
        diagramNode.id = newId;
        diagramNode.annotations[0].content = node.Description;
        diagramNode.offsetX = node.PosX;
        diagramNode.offsetY = node.PosY;
        diagramNode.width = node.Width;
        diagramNode.height = node.Height;
        diagramNode.addInfo = { "wfelemid": node.Id, "wftype": "Node" };
        diagramNode.style.fill = this.getRGBAColor(node.ColorRed, node.ColorGreen, node.ColorBlue, node.Opacity);
        switch (node.ColorMode) {
            case WorkflowModel_1.ColorMode.Active: {
                diagramNode.style.fill = this.getRGBAColor(0, 112, 192, 1.0);
                diagramNode.style.strokeWidth = 2.0;
                diagramNode.annotations[0].style.color = this.getRGBAColor(255, 255, 255, 1.0);
                diagramNode.annotations[0].style.bold = true;
                break;
            }
            case WorkflowModel_1.ColorMode.Future: {
                diagramNode.style.fill = this.getRGBAColor(216, 204, 165, 1.0);
                diagramNode.style.strokeWidth = 1.0;
                diagramNode.annotations[0].style.color = this.getRGBAColor(0, 0, 0, 1.0);
                diagramNode.annotations[0].style.bold = false;
                break;
            }
            case WorkflowModel_1.ColorMode.Visisted: {
                diagramNode.style.fill = this.getRGBAColor(247, 245, 237, 1.0);
                diagramNode.style.strokeWidth = 1.0;
                diagramNode.annotations[0].style.color = this.getRGBAColor(0, 0, 0, 1.0);
                diagramNode.annotations[0].style.bold = false;
                break;
            }
        }
    }
    addWfNode(elem) {
        let that = this;
        let newDiagramNode = undefined;
        // Get shape
        if (elem instanceof WorkflowModel_1.ActivityNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.Activity]);
        else if (elem instanceof WorkflowModel_1.StartNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.Start]);
        else if (elem instanceof WorkflowModel_1.EndNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.End]);
        else if (elem instanceof WorkflowModel_1.ViewNode)
            newDiagramNode = that.m_viewShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.View]);
        else if (elem instanceof WorkflowModel_1.GuiNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.Gui]);
        else if (elem instanceof WorkflowModel_1.ForkNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.Fork]);
        else if (elem instanceof WorkflowModel_1.WaitNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.Wait]);
        else if (elem instanceof WorkflowModel_1.DynamicForkNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.DynamicFork]);
        else if (elem instanceof WorkflowModel_1.DynamicWaitNode)
            newDiagramNode = that.m_workflowShapes.find(shape => shape.id == WorkflowShapeId[WorkflowShapeId.DynamicWait]);
        else if (elem instanceof WorkflowModel_1.WfTextLabelNode)
            newDiagramNode = that.m_visualShapes.find(shape => shape.id == VisualShapeId[VisualShapeId.Text]);
        else if (elem instanceof WorkflowModel_1.WfTextBoxNode)
            newDiagramNode = that.m_visualShapes.find(shape => shape.id == VisualShapeId[VisualShapeId.Rectangle]);
        if (newDiagramNode) {
            // Add node defaults
            newDiagramNode = JSON.parse(JSON.stringify(newDiagramNode));
            // Set data
            that.setDiagramNodeData(newDiagramNode, elem);
            if (elem instanceof WorkflowModel_1.WfTextNode) {
                if (elem instanceof WorkflowModel_1.WfTextLabelNode) {
                    that.m_diagram.setActiveLayer("textlabelLayer");
                    newDiagramNode.addInfo["wftype"] = "TextLabelNode";
                }
                else if (elem instanceof WorkflowModel_1.WfTextBoxNode) {
                    that.m_diagram.setActiveLayer("textboxLayer");
                    newDiagramNode.addInfo["wftype"] = "TextBoxNode";
                    newDiagramNode.style.strokeColor = that.getRGBAColor(elem.BorderColorRed, elem.BorderColorGreen, elem.BorderColorBlue, elem.BorderOpacity);
                }
                newDiagramNode.annotations[0].style.fontSize = elem.FontSize;
                if (elem.Description)
                    newDiagramNode.annotations[0].content = elem.Description;
                newDiagramNode.annotations[0].style.color = that.getRGBAColor(elem.TextColorRed, elem.TextColorGreen, elem.TextColorBlue, elem.TextOpacity);
            }
            else {
                that.m_diagram.setActiveLayer("shapeLayer");
                let a_half = Math.tan(18 * Math.PI / 180) * 0.5;
                let x = Math.cos((36 / 180) * Math.PI) * 0.5;
                let y = Math.sin((36 / 180) * Math.PI) * 0.5;
                let ports = [
                    { id: "portN", shape: "Circle", offset: { x: .5, y: 0 } },
                    { id: "portE", shape: "Circle", offset: { x: 1, y: .5 } },
                    { id: "portS", shape: "Circle", offset: { x: 0.5, y: 1 } },
                    { id: "portW", shape: "Circle", offset: { x: 0, y: 0.5 } },
                ];
                /*if(elem instanceof ActivityNode || elem instanceof ViewNode || elem instanceof GuiNode){
                    ports.push( { id: "portNW", shape: "Circle", offset: { x: 0, y: 0.0 } },
                                { id: "portNE", shape: "Circle", offset: { x: 1, y: 0 } },
                                { id: "portSE", shape: "Circle", offset: { x: 1, y: 1 } },
                                { id: "portSW", shape: "Circle", offset: { x: 0, y: 1 } });
    
                }
                else*/ if (elem instanceof WorkflowModel_1.DynamicWaitNode || elem instanceof WorkflowModel_1.DynamicForkNode) {
                    ports.push({ id: "nne", shape: "Circle", offset: { x: a_half + 0.5, y: 0 } }, { id: "nnw", shape: "Circle", offset: { x: 0.5 - a_half, y: 0 } }, { id: "sse", shape: "Circle", offset: { x: a_half + 0.5, y: 1 } }, { id: "ssw", shape: "Circle", offset: { x: 0.5 - a_half, y: 1 } }, { id: "ese", shape: "Circle", offset: { x: x + 0.5, y: y + 0.5 } }, { id: "ene", shape: "Circle", offset: { x: x + 0.5, y: 0.5 - y } }, { id: "wsw", shape: "Circle", offset: { x: 0.5 - x, y: y + 0.5 } }, { id: "wnw", shape: "Circle", offset: { x: 0.5 - x, y: 0.5 - y } });
                }
                newDiagramNode.ports = ports;
            }
            let node = that.m_diagram.add(newDiagramNode);
            if (that.m_mode === WfMode.View) {
                node.constraints = ej2_diagrams_1.NodeConstraints.None | ej2_diagrams_1.NodeConstraints.PointerEvents | ej2_diagrams_1.NodeConstraints.Select | ej2_diagrams_1.NodeConstraints.InConnect | ej2_diagrams_1.NodeConstraints.OutConnect;
                node.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
            }
            else {
                node.constraints = ej2_diagrams_1.NodeConstraints.Default;
                node.constraints = node.constraints & ~(ej2_diagrams_1.NodeConstraints.Rotate);
                node.constraints = node.constraints & ~(ej2_diagrams_1.NodeConstraints.AllowDrop);
                if (elem instanceof WorkflowModel_1.WfTextNode) {
                    node.constraints = node.constraints & ~(ej2_diagrams_1.NodeConstraints.InConnect);
                    node.constraints = node.constraints & ~(ej2_diagrams_1.NodeConstraints.OutConnect);
                }
                else {
                    node.constraints |= ej2_diagrams_1.NodeConstraints.AspectRatio;
                    node.constraints |= ej2_diagrams_1.NodeConstraints.InConnect;
                    node.constraints |= ej2_diagrams_1.NodeConstraints.OutConnect;
                    node.constraints |= ej2_diagrams_1.NodeConstraints.PointerEvents;
                }
            }
            that.m_diagram.dataBind();
            return node;
        }
        return undefined;
    }
    componentToHex(c) {
        let hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }
    getRGBAColor(r, g, b, opacity) {
        return "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + "," + opacity.toString() + ")";
    }
    setConnectorConstraints(connector) {
        let that = this;
        if (that.m_levelOfDetail === WfDetailLevel.Detailed) {
            if (that.m_mode === WfMode.View) {
                connector.constraints = ej2_diagrams_1.ConnectorConstraints.None | ej2_diagrams_1.ConnectorConstraints.Select | ej2_diagrams_1.ConnectorConstraints.PointerEvents | ej2_diagrams_1.ConnectorConstraints.Bridging;
                connector.annotations[0].constraints = ej2_diagrams_1.AnnotationConstraints.ReadOnly;
            }
            else {
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.Bridging;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.AllowDrop;
                //connector.constraints |= ConnectorConstraints.InheritLineRouting;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.InheritBridging;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.BridgeObstacle;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.DragSegmentThumb;
                // connector.constraints |= ConnectorConstraints.ConnectToNearByElement;
                // connector.constraints |= ConnectorConstraints.ConnectToNearByNode;
                // connector.constraints |= ConnectorConstraints.ConnectToNearByPort;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.Select;
                connector.constraints |= ej2_diagrams_1.ConnectorConstraints.PointerEvents;
            }
        }
        else {
            connector.constraints = ej2_diagrams_1.ConnectorConstraints.None | ej2_diagrams_1.ConnectorConstraints.Bridging | ej2_diagrams_1.ConnectorConstraints.Delete;
        }
    }
    addWfConnector(wfConnector) {
        let that = this;
        let newDiagramConnector = JSON.parse(JSON.stringify(that.m_connectors.find(conncector => conncector.id == ConnectorId[ConnectorId.Orthogonal])));
        // Add connector defaults
        that.setConnectorDefaults(newDiagramConnector);
        newDiagramConnector.id = that.convertId(wfConnector.Id);
        if (wfConnector.SourceNodeId) {
            newDiagramConnector.sourceID = that.convertId(wfConnector.SourceNodeId);
            newDiagramConnector.sourcePortID = wfConnector.SourcePortId;
        }
        else {
            newDiagramConnector.sourcePoint.x = wfConnector.SourcePointPosX;
            newDiagramConnector.sourcePoint.y = wfConnector.SourcePointPosY;
        }
        if (wfConnector.TargetNodeId) {
            newDiagramConnector.targetID = that.convertId(wfConnector.TargetNodeId);
            newDiagramConnector.targetPortID = wfConnector.TargetPortId;
        }
        else {
            newDiagramConnector.targetPoint.x = wfConnector.TargetPointPosX;
            newDiagramConnector.targetPoint.y = wfConnector.TargetPointPosY;
        }
        newDiagramConnector.addInfo = { "wfelemid": wfConnector.Id, "wftype": "Connector" };
        if (wfConnector.Description)
            newDiagramConnector.annotations[0].content = wfConnector.Description;
        that.m_diagram.setActiveLayer("shapeLayer");
        let connector = that.m_diagram.add(newDiagramConnector);
        wfConnector.SourcePointPosX = connector.sourcePoint.x;
        wfConnector.SourcePointPosY = connector.sourcePoint.y;
        wfConnector.TargetPointPosX = connector.targetPoint.x;
        wfConnector.TargetPointPosY = connector.targetPoint.y;
        // Restore (orthogonal) segments of connector if there are any
        let segmentList = [];
        wfConnector.SegmentList.forEach(wfSegment => {
            if (wfSegment.Direction && wfSegment.Length) {
                let segment = new ej2_diagrams_1.OrthogonalSegment(/*parent*/ connector, /* propName */ "segments", /* defaultValue */ undefined /*, isArray */);
                segment.type = "Orthogonal";
                segment.direction = wfSegment.Direction;
                segment.length = wfSegment.Length;
                segmentList.push(segment);
            }
        });
        connector.segments = segmentList;
        this.setConnectorConstraints(connector);
        return connector;
    }
    setWorkflowModel() {
        let that = this;
        that.m_diagram.clear();
        //Set nodes
        for (let node of that.m_workflowModel.NodeList)
            if ((that.m_levelOfDetail === WfDetailLevel.Detailed && !(node instanceof WorkflowModel_1.ViewNode)) || (that.m_levelOfDetail === WfDetailLevel.Overall && (node instanceof WorkflowModel_1.ViewNode)))
                that.addWfNode(node);
        //Set connectors
        for (let connector of that.m_workflowModel.ConnectorList)
            if ((that.m_levelOfDetail === WfDetailLevel.Detailed && !connector.IsViewNode) || (that.m_levelOfDetail === WfDetailLevel.Overall && connector.IsViewNode))
                that.addWfConnector(connector);
        that.m_diagram.dataBind();
        that.m_diagram.fitToPage();
    }
    updateDiagram(newWorkflowModel) {
        let that = this;
        that.m_ignoreModelManipulation = true;
        //remove deleted elements and update elements
        for (let oldNode of that.m_workflowModel.NodeList) {
            let newNode = newWorkflowModel.NodeList.find(n => n.Id === oldNode.Id);
            if (newNode) {
                if (newNode.Etag != oldNode.Etag) {
                    //Update node
                    let nodeToChange = that.getDiagramObjectById(oldNode.Id);
                    if (nodeToChange && nodeToChange instanceof ej2_diagrams_1.Node) {
                        nodeToChange.width = newNode.Width;
                        nodeToChange.height = newNode.Height;
                        nodeToChange.offsetX = newNode.PosX;
                        nodeToChange.offsetY = newNode.PosY;
                        nodeToChange.style.fill = that.getRGBAColor(newNode.ColorRed, newNode.ColorGreen, newNode.ColorBlue, newNode.Opacity);
                        if (newNode instanceof WorkflowModel_1.WfTextNode) {
                            nodeToChange.annotations[0].content = newNode.Description;
                            nodeToChange.annotations[0].style.color = that.getRGBAColor(newNode.TextColorRed, newNode.TextColorGreen, newNode.TextColorBlue, newNode.TextOpacity);
                            nodeToChange.annotations[0].style.fontSize = newNode.FontSize;
                            if (newNode instanceof WorkflowModel_1.WfTextBoxNode) {
                                nodeToChange.style.strokeColor = that.getRGBAColor(newNode.BorderColorRed, newNode.BorderColorGreen, newNode.BorderColorBlue, newNode.BorderOpacity);
                                nodeToChange.annotations[0].verticalAlignment = newNode.VerticalAlign;
                                if (newNode.VerticalAlign === WorkflowModel_1.VerticalAlignment.Top)
                                    nodeToChange.annotations[0].offset.y = 0;
                                else if (newNode.VerticalAlign === WorkflowModel_1.VerticalAlignment.Center)
                                    nodeToChange.annotations[0].offset.y = 0.5;
                                else if (newNode.VerticalAlign === WorkflowModel_1.VerticalAlignment.Bottom)
                                    nodeToChange.annotations[0].offset.y = 1;
                                nodeToChange.annotations[0].horizontalAlignment = newNode.HorizontalAlig;
                                if (newNode.HorizontalAlig === WorkflowModel_1.HorizontalAlignment.Left)
                                    nodeToChange.annotations[0].offset.x = 0;
                                else if (newNode.HorizontalAlig === WorkflowModel_1.HorizontalAlignment.Center)
                                    nodeToChange.annotations[0].offset.x = 0.5;
                                else if (newNode.HorizontalAlig === WorkflowModel_1.HorizontalAlignment.Right)
                                    nodeToChange.annotations[0].offset.x = 1;
                            }
                        }
                        else
                            nodeToChange.annotations[0].content = newNode.Description;
                        that.m_diagram.dataBind();
                    }
                }
            }
            else {
                let objToDelete = that.getDiagramObjectById(oldNode.Id);
                if (objToDelete)
                    that.m_diagram.remove(objToDelete);
            }
        }
        //add new elements
        for (let newNode of newWorkflowModel.NodeList) {
            let oldNode = that.m_workflowModel.NodeList.find(n => n.Id === newNode.Id);
            //add new node
            if (!oldNode)
                that.addWfNode(newNode);
        }
        //Connectors
        //remove deleted elements and update elements
        for (let oldConnector of that.m_workflowModel.ConnectorList) {
            let newConnector = newWorkflowModel.ConnectorList.find(n => n.Id === oldConnector.Id);
            if (newConnector) {
                if (newConnector.Etag != oldConnector.Etag) {
                    //Update Connector
                    let connectorToChange = that.getDiagramObjectById(oldConnector.Id);
                    if (connectorToChange && connectorToChange instanceof ej2_diagrams_1.Connector) {
                        if (newConnector.SourceNodeId) {
                            connectorToChange.sourceID = that.convertId(newConnector.SourceNodeId);
                            connectorToChange.sourcePortID = newConnector.SourcePortId;
                        }
                        else {
                            connectorToChange.sourceID = undefined;
                            connectorToChange.sourcePortID = undefined;
                        }
                        that.m_diagram.dataBind();
                        connectorToChange.sourcePoint.x = newConnector.SourcePointPosX;
                        connectorToChange.sourcePoint.y = newConnector.SourcePointPosY;
                        if (newConnector.TargetNodeId) {
                            connectorToChange.targetID = that.convertId(newConnector.TargetNodeId);
                            connectorToChange.targetPortID = newConnector.TargetPortId;
                        }
                        else {
                            connectorToChange.targetID = undefined;
                            connectorToChange.targetPortID = undefined;
                        }
                        // Update segments
                        let segmentList = [];
                        newConnector.SegmentList.forEach(wfSegment => {
                            if (wfSegment.Direction && wfSegment.Length) {
                                let segment = new ej2_diagrams_1.OrthogonalSegment(/*parent*/ connectorToChange, /* propName */ "segments", /* defaultValue */ undefined /*, isArray */);
                                segment.type = "Orthogonal";
                                segment.direction = wfSegment.Direction;
                                segment.length = wfSegment.Length;
                                segmentList.push(segment);
                            }
                        });
                        connectorToChange.segments = segmentList;
                        that.m_diagram.dataBind();
                        connectorToChange.targetPoint.x = newConnector.TargetPointPosX;
                        connectorToChange.targetPoint.y = newConnector.TargetPointPosY;
                        connectorToChange.annotations[0].content = newConnector.Description;
                        that.m_diagram.dataBind();
                    }
                    else {
                        if ((that.m_levelOfDetail === WfDetailLevel.Detailed && !newConnector.IsViewNode) ||
                            (that.m_levelOfDetail === WfDetailLevel.Overall && newConnector.IsViewNode))
                            that.addWfConnector(newConnector);
                    }
                }
            }
            else {
                let objToDelete = that.getDiagramObjectById(oldConnector.Id);
                if (objToDelete)
                    that.m_diagram.remove(objToDelete);
            }
        }
        //add new elements
        for (let newConnector of newWorkflowModel.ConnectorList) {
            let oldConnector = that.m_workflowModel.ConnectorList.find(n => n.Id === newConnector.Id);
            //add new connector
            if (!oldConnector) {
                if ((that.m_levelOfDetail === WfDetailLevel.Detailed && !newConnector.IsViewNode) ||
                    (that.m_levelOfDetail === WfDetailLevel.Overall && newConnector.IsViewNode))
                    that.addWfConnector(newConnector);
            }
        }
        that.m_ignoreModelManipulation = false;
    }
    loadDiagram() {
        let that = this;
        that.createDiagram();
        let yOffset = 0;
        for (let wfNode of that.m_workflowModel.NodeList) {
            if ((wfNode.PosY + wfNode.Height) > yOffset)
                yOffset = wfNode.PosY + wfNode.Height;
        }
        //yOffset *= 5;
        //for(let wfNode of that.m_workflowModel.NodeList){
        //    wfNode.PosX = wfNode.PosX * 5 + (wfNode.Width * 5 / 2) ;
        //    wfNode.PosY = (-wfNode.PosY * 5 ) + yOffset;
        //    wfNode.Width = wfNode.Width * 5;
        //    wfNode.Height = wfNode.Height * 5;
        //}
        that.setWorkflowModel();
        if (that.m_mode === WfMode.Edit) {
            that.addHistoryObject();
            that.m_$sidebar.off("keydown").on("keydown", (e) => {
                if (e.ctrlKey) {
                    if (e.keyCode === 90) { //undo
                        e.stopPropagation();
                        e.preventDefault();
                        that.undo();
                    }
                    else if (e.keyCode === 89) { //redo
                        e.stopPropagation();
                        e.preventDefault();
                        that.redo();
                    }
                }
            });
            that.m_$properties.off("keydown").on("keydown", (e) => {
                if (e.ctrlKey) {
                    if (e.keyCode === 90) { //undo
                        e.stopPropagation();
                        e.preventDefault();
                        that.undo();
                    }
                    else if (e.keyCode === 89) { //redo
                        e.stopPropagation();
                        e.preventDefault();
                        that.redo();
                    }
                }
            });
        }
    }
    rectangleIntersect(rect1, rect2) {
        return Math.max(rect1.left, rect2.left) < Math.min(rect1.right, rect2.right) && Math.max(rect1.top, rect2.top) < Math.min(rect1.bottom, rect2.bottom);
    }
}
exports.WorkflowManager = WorkflowManager;
class PropertyAbstractItem {
    constructor(manager) {
        this.manager = manager;
    }
    remove() {
        if (this.container)
            this.container.remove();
    }
}
class PropertyPathItem extends PropertyAbstractItem {
    constructor(manager, currentLink) {
        super(manager);
        this.currentLink = currentLink;
    }
    init(jQueryElem) {
        let that = this;
        that.container = $("<div class='wfpropertyitem'/>").appendTo(jQueryElem);
        let propertyLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.container);
        let propertyLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(propertyLabelOuterContainer);
        let propertyControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.container);
        let propertyControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(propertyControlOuterContainer);
        $("<label>" + "Path" + "</label>").appendTo(propertyLabelInnerContainer);
        let input = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(propertyControlInnerContainer);
        input.val(that.currentLink.Path);
        input.on("input", (e) => {
            let value = input.val();
            that.currentLink.Path = value.toString();
            this.manager.addHistoryObject();
        });
        if (that.manager.Mode === WfMode.View) {
            input.addClass("wfReadOnly");
            input.prop("readonly", "readonly");
        }
    }
    markSearchResult() {
        this.container.addClass("wfMark");
    }
    clearSearchResult() {
        this.container.removeClass("wfMark");
    }
    markError() {
        this.container.addClass("wfpropertyerroritem");
    }
    clearError() {
        this.container.removeClass("wfpropertyerroritem");
    }
    get ConnectorId() {
        return this.currentLink.Id;
    }
}
class PropertyBaseItem extends PropertyAbstractItem {
    constructor(manager, propertyId, currentNode) {
        super(manager);
        this.propertyId = propertyId;
        this.currentNode = currentNode;
    }
    init(jQueryElem) {
        let that = this;
        that.container = $("<div class='wfpropertyitem'/>").appendTo(jQueryElem);
        let propertyLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.container);
        let propertyLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(propertyLabelOuterContainer);
        let propertyControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.container);
        that.controlContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(propertyControlOuterContainer);
        $("<label>" + that.propertyId + "</label>").appendTo(propertyLabelInnerContainer);
    }
    remove() {
        this.container.remove();
    }
    markSearchResult() {
        this.container.addClass("wfMark");
    }
    markError() {
        this.container.addClass("wfpropertyerroritem");
    }
    clearError() {
        this.container.removeClass("wfpropertyerroritem");
    }
    clearSearchResult() {
        this.container.removeClass("wfMark");
    }
    get NodeId() {
        return this.currentNode.Id;
    }
}
class PropertyIdItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode, id) {
        super(manager, propertyId, currentNode);
        this.id = id;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let input = $("<input class='wfInput k-textbox wfReadOnly' readonly>").appendTo(this.controlContainer);
        input.val(this.id);
    }
    getId() {
        return this.id;
    }
}
class PropertyGuiIdItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode, guiid) {
        super(manager, propertyId, currentNode);
        this.guiid = guiid;
        this.guiNode = currentNode;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let input = $("<input class='wfInput k-textbox'>").appendTo(that.controlContainer);
        if (that.guiid)
            input.val(that.guiid);
        input.on("change", (e) => {
            let value = input.val().toString();
            that.guiNode.GuiId = value;
            that.manager.checkPropertyChange(that.NodeId, that.NodeId, "Node", "GuiId", value);
            //Check if value could be docid
            if (value && parseInt(value)) {
                Utilities_1.synUtil.getAJAXData({
                    method: "GET",
                    url: Utilities_1.synUtil.getWSUrl("WorkflowGetWorkflowGuiParameterData") + value,
                    done: (data) => {
                        if (data) {
                            that.manager.m_selectedProperties.forEach((value) => {
                                if (value instanceof PropertyBaseItem && !(value.propertyId == "Id" || value.propertyId == "GuiId" || value.propertyId == "ReadValuesFromGUI" || value.propertyId == "WriteValuesToGUI"))
                                    value.remove();
                            });
                            that.manager.m_selectedProperties = that.manager.m_selectedProperties.filter(propItem => propItem instanceof PropertyBaseItem && (propItem.propertyId == "Id" || propItem.propertyId == "GuiId" || propItem.propertyId == "ReadValuesFromGUI" || propItem.propertyId == "WriteValuesToGUI"));
                            for (let param of that.guiNode.ParamList) {
                                if (!(param.Id == "ReadValuesFromGUI" || param.Id == "WriteValuesToGUI")) {
                                    let searchResult = that.manager.getSearchResult(that.currentNode.Id, param.Id, "Node");
                                    if (searchResult) {
                                        that.manager.removeSearchProperty(that.currentNode.Id, param.Id, "Node", "Param:Id");
                                        that.manager.removeSearchProperty(that.currentNode.Id, param.Id, "Node", "Param:Value");
                                        that.manager.refreshSearchGrid();
                                    }
                                }
                            }
                            that.guiNode.ParamList = that.guiNode.ParamList.filter(param => param.Id == "ReadValuesFromGUI" || param.Id == "WriteValuesToGUI");
                            for (let functionParam of data) {
                                let initValue = "";
                                let direction = WorkflowManager.convertDirectionNumberToString(functionParam.direction);
                                let required = WorkflowManager.convertRequiredNumberToString(functionParam.required);
                                if (that.guiNode.ParamList) {
                                    let param = that.guiNode.ParamList.find(node => node.Id === functionParam.name && node.Direction === direction);
                                    if (param)
                                        initValue = param.Value;
                                    else {
                                        let newParam = new WorkflowModel_1.Param();
                                        newParam.Id = functionParam.name;
                                        newParam.Direction = direction;
                                        that.guiNode.ParamList.push(newParam);
                                    }
                                }
                                let item = new PropertyParamItem(that.manager, functionParam.name, that.currentNode, initValue, direction, required, functionParam.typeName);
                                item.init(jQueryElem);
                                that.manager.m_selectedProperties.push(item);
                            }
                        }
                    },
                });
            }
            this.manager.addHistoryObject();
        });
        if (that.manager.Mode === WfMode.View) {
            input.addClass("wfReadOnly");
            input.prop("readonly", "readonly");
        }
    }
}
class PropertyReferencedShapesItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode) {
        super(manager, propertyId, currentNode);
        this.propertyId = propertyId;
        this.currentNode = currentNode;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let viewInput = $("<select style='width:100%' class='wfInput' style='overflow-wrap: break-word;display:block;vertical-align:middle;' >").appendTo(that.controlContainer);
        let viewNodeNames = [];
        let alreadyReferencedNodeIds = [];
        let viewNodes = that.manager.m_workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.ViewNode);
        for (let viewNode of viewNodes) {
            if (viewNode.Id != this.currentNode.Id && viewNode.ReferencedShapes.length > 0) {
                for (let nodeId of viewNode.ReferencedShapes) {
                    if (alreadyReferencedNodeIds.indexOf(nodeId) === -1)
                        alreadyReferencedNodeIds.push(nodeId);
                }
            }
        }
        let noneViewNodes = that.manager.m_workflowModel.NodeList.filter(node => !(node instanceof WorkflowModel_1.ViewNode) && alreadyReferencedNodeIds.indexOf(node.Id) === -1);
        for (let viewNode of noneViewNodes)
            viewNodeNames.push({ id: viewNode.Id, value: viewNode.Description + " " + viewNode.Id });
        let viewMultiSelect = viewInput.kendoMultiSelect({
            dataSource: viewNodeNames,
            dataTextField: "value",
            dataValueField: "id",
            filter: "contains",
            placeholder: Utilities_1.synUtil.Strings.getValue("wf_referencednodes_placeholder"),
            change: (e) => {
                that.currentNode.ReferencedShapes = e.sender.value();
                that.manager.updateViewConnections(that.currentNode, true);
                that.manager.addHistoryObject();
            }
        }).data("kendoMultiSelect");
        viewMultiSelect.value(this.currentNode.ReferencedShapes);
        if (noneViewNodes.length === 0 || that.manager.Mode === WfMode.View) {
            //viewInput.prop("readonly", true);
            viewMultiSelect.enable(false);
            viewMultiSelect.input.closest(".k-multiselect").attr("readonly", "readonly");
            viewMultiSelect.input.closest(".k-multiselect-wrap").addClass("wfReadOnly");
        }
        else {
            //viewInput.prop("readonly", false);
            viewMultiSelect.enable(true);
            viewMultiSelect.input.closest(".k-multiselect").removeAttr("readonly");
            viewMultiSelect.input.closest(".k-multiselect-wrap").removeClass("wfReadOnly");
        }
    }
}
class PropertyViewItem extends PropertyAbstractItem {
    constructor(manager, currentNodes) {
        super(manager);
        this.currentNodes = currentNodes;
    }
    init(jQueryElem) {
        let that = this;
        that.container = $("<div class='wfpropertyitem'/>").appendTo(jQueryElem);
        let propertyLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.container);
        let propertyLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(propertyLabelOuterContainer);
        let propertyControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.container);
        that.controlContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(propertyControlOuterContainer);
        $("<label> ViewNode </label>").appendTo(propertyLabelInnerContainer);
        let viewInput = $("<input style='width:100%''>").appendTo(that.controlContainer);
        let viewNodeNames = [];
        let viewNodes = that.manager.m_workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.ViewNode); // && (node.ReferencedShapes.indexOf(node.Id) != 1 || node.ReferencedShapes.length == 0) ) as ViewNode[];
        for (let viewNode of viewNodes)
            viewNodeNames.push({ id: viewNode.Id, value: viewNode.Description + " " + viewNode.Id });
        let diffValue = false;
        let value = undefined;
        let firstNode = true;
        if (viewNodes.length != 0) {
            for (let currentNode of that.currentNodes) {
                for (let viewNode of viewNodes) {
                    if (viewNode.ReferencedShapes && viewNode.ReferencedShapes.length > 0) {
                        if (viewNode.ReferencedShapes.indexOf(currentNode.Id) != -1) {
                            if (firstNode)
                                value = viewNode.Id;
                            else {
                                if (value != viewNode.Id) {
                                    diffValue = true;
                                }
                            }
                        }
                    }
                }
                firstNode = false;
            }
        }
        let viewCombobox = viewInput.kendoComboBox({
            dataSource: viewNodeNames,
            dataTextField: "value",
            dataValueField: "id",
            filter: "contains",
            change: (e) => {
                let val = e.sender.value();
                let viewNodesToUpdate = [];
                for (let currentNode of this.currentNodes) {
                    for (let viewNode of viewNodes) {
                        if (val && val === viewNode.Id) {
                            if (viewNode.ReferencedShapes.indexOf(currentNode.Id) === -1)
                                viewNode.ReferencedShapes.push(currentNode.Id);
                            if (viewNodesToUpdate.indexOf(viewNode) === -1)
                                viewNodesToUpdate.push(viewNode);
                        }
                        else {
                            let idx = viewNode.ReferencedShapes.indexOf(currentNode.Id);
                            if (idx != -1) {
                                viewNode.ReferencedShapes.splice(idx, 1);
                                if (viewNodesToUpdate.indexOf(viewNode) === -1)
                                    viewNodesToUpdate.push(viewNode);
                            }
                        }
                    }
                }
                for (let viewNodeToUpdate of viewNodesToUpdate)
                    that.manager.updateViewConnections(viewNodeToUpdate, false);
                this.manager.addHistoryObject();
            },
        }).data("kendoComboBox");
        if (viewNodes.length === 0 || that.manager.Mode === WfMode.View) {
            viewInput.prop("readonly", true);
            viewCombobox.enable(false);
            viewCombobox.input.closest(".k-input").addClass("wfReadOnly");
        }
        else {
            viewInput.prop("readonly", false);
            viewCombobox.enable(true);
            viewCombobox.input.closest(".k-input").removeClass("wfReadOnly");
            if (diffValue) {
                viewCombobox.input.attr("placeholder", Utilities_1.synUtil.Strings.getValue("wf_diff_property_label"));
            }
            else {
                if (value)
                    viewCombobox.value(value);
            }
        }
    }
}
class PropertyFunctionIdItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode) {
        super(manager, propertyId, currentNode);
        this.acticityNode = currentNode;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let functionInput = $("<input style='width:100%''>").appendTo(that.controlContainer);
        let functionCombobox = functionInput.kendoComboBox({
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataSource: {
                transport: {
                    read: (options) => {
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("WorkflowGetWorkflowFunctionNames"),
                            done: (functionNames) => {
                                options.success(functionNames);
                            },
                        });
                    }
                }
            },
            filter: "contains",
            change: (e) => {
                if (e.sender.dataItem()) {
                    let functionId = e.sender.value();
                    if (that.currentNode instanceof WorkflowModel_1.ActivityNode) {
                        if (that.currentNode.FunctionId != functionId) {
                            that.currentNode.FunctionId = functionId;
                            for (let param of that.currentNode.ParamList) {
                                let searchResult = that.manager.getSearchResult(that.currentNode.Id, param.Id, "Node");
                                if (searchResult) {
                                    that.manager.removeSearchProperty(that.currentNode.Id, param.Id, "Node", "Param:Id");
                                    that.manager.removeSearchProperty(that.currentNode.Id, param.Id, "Node", "Param:Value");
                                    that.manager.refreshSearchGrid();
                                }
                            }
                            that.currentNode.ParamList.splice(0, that.currentNode.ParamList.length);
                            that.manager.clearProperties();
                            that.manager.setProperties(that.currentNode.Id);
                        }
                    }
                    this.manager.addHistoryObject();
                }
            },
        }).data("kendoComboBox");
        if (that.acticityNode.FunctionId)
            functionCombobox.value(that.acticityNode.FunctionId);
        else
            functionCombobox.value("");
        if (that.manager.Mode === WfMode.View) {
            functionInput.prop("readonly", true);
            functionCombobox.enable(false);
            let target = functionCombobox.input.closest(".k-input");
            target.addClass("wfReadOnly");
        }
    }
}
class PropertyItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode, initValue) {
        super(manager, propertyId, currentNode);
        this.initValue = initValue;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let input = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(that.controlContainer);
        if (that.initValue)
            input.val(that.initValue);
        input.on("input", (e) => {
            let value = input.val();
            that.currentNode[that.propertyId] = value.toString();
            that.manager.checkPropertyChange(that.currentNode.Id, that.currentNode.Id, "Node", that.propertyId, value.toString());
            this.manager.addHistoryObject();
        });
        if (that.manager.Mode === WfMode.View) {
            input.addClass("wfReadOnly");
            input.prop("readonly", "readonly");
        }
    }
}
class PropertyParamItem extends PropertyBaseItem {
    constructor(manager, propertyId, currentNode, initValue, direction, required, type) {
        super(manager, propertyId, currentNode);
        this.initValue = initValue;
        this.direction = direction;
        this.required = required;
        this.type = type;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        if (that.type)
            that.type = that.type.replace("[]", "Array");
        that.container.prop("title", "Direction: " + that.direction + " Required: " + that.required + " Type: " + that.type);
        that.input = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(that.controlContainer);
        if (that.initValue)
            that.input.val(that.initValue);
        that.highlightRequired();
        if (that.manager.Mode === WfMode.View) {
            that.input.addClass("wfReadOnly");
            that.input.prop("readonly", "readonly");
        }
        that.input.on("input", (e) => {
            that.highlightRequired();
            let value = that.input.val();
            if (that.currentNode instanceof WorkflowModel_1.ActivityNode || that.currentNode instanceof WorkflowModel_1.GuiNode) {
                let param = that.currentNode.ParamList.find(tmpParam => tmpParam.Id === that.propertyId);
                if (param) {
                    param.Value = value.toString();
                }
                else {
                    param = new WorkflowModel_1.Param();
                    param.Id = that.propertyId;
                    param.Direction = that.direction;
                    param.Value = value.toString();
                    that.currentNode.ParamList.push(param);
                }
                that.manager.checkPropertyChange(that.currentNode.Id, param.Id, "Node", "Param:Value", value.toString());
            }
            this.manager.addHistoryObject();
        });
    }
    highlightRequired() {
        if (this.required === "mandatory" && !this.input.val())
            this.input.addClass("wfMandatory");
        else
            this.input.removeClass("wfMandatory");
    }
}
class PropertyVariableItem extends PropertyAbstractItem {
    constructor(manager, variable) {
        super(manager);
        this.variable = variable;
    }
    init(jQueryElem) {
        let that = this;
        that.container = $("<div class='variablecontainer'/>").appendTo(jQueryElem);
        let delButtonContainer = $("<div class='variabledelcontainer'/>").appendTo(that.container);
        if (that.manager.Mode === WfMode.Edit) {
            let delButton = $("<i class='fa fa-times delIcon' aria-hidden='true' style='box-sizing:border-box;width:1em; color:red; display:none; float: right'></i>").appendTo(delButtonContainer);
            delButton.on("click", () => {
                let idx = that.manager.m_workflowModel.VariableList.indexOf(that.variable);
                if (idx != -1) {
                    that.manager.m_workflowModel.VariableList.splice(idx, 1);
                    that.container.remove();
                }
                else {
                    let dynamicforkNodes = that.manager.m_workflowModel.NodeList.filter(node => node instanceof WorkflowModel_1.DynamicForkNode);
                    if (dynamicforkNodes) {
                        for (let dfNode of dynamicforkNodes) {
                            idx = dfNode.VariableList.indexOf(that.variable);
                            if (idx != -1) {
                                dfNode.VariableList.splice(idx, 1);
                                that.container.remove();
                            }
                        }
                    }
                }
            });
        }
        that.idPropertyContainer = $("<div class='wfpropertyitem wfvariableitem wfpropertyfirstitem'/>").appendTo(that.container);
        let idLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.idPropertyContainer);
        let idLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(idLabelOuterContainer);
        let idControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.idPropertyContainer);
        let idControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(idControlOuterContainer);
        that.additionalContainer = $("<div class='additionalContainer wfhideproperty'/>").appendTo(that.container);
        let typePropertyContainer = $("<div class='wfpropertyitem wfvariableitem'/>").appendTo(that.additionalContainer);
        let typeLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(typePropertyContainer);
        let typeLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(typeLabelOuterContainer);
        let typeControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(typePropertyContainer);
        let typeControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(typeControlOuterContainer);
        let isArrayPropertyContainer = $("<div class='wfpropertyitem wfvariableitem'/>").appendTo(that.additionalContainer);
        let isArrayLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(isArrayPropertyContainer);
        let isArrayLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(isArrayLabelOuterContainer);
        let isArrayControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(isArrayPropertyContainer);
        let isArrayControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(isArrayControlOuterContainer);
        that.valuePropertyContainer = $("<div class='wfpropertyitem wfvariableitem'/>").appendTo(that.additionalContainer);
        let valueLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.valuePropertyContainer);
        let valueLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(valueLabelOuterContainer);
        let valueControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.valuePropertyContainer);
        let valueControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(valueControlOuterContainer);
        that.descriptionPropertyContainer = $("<div class='wfpropertyitem wfvariableitem'/>").appendTo(that.additionalContainer);
        let descriptionLabelOuterContainer = $("<div class='wfpropertylabeloutercontainer'>").appendTo(that.descriptionPropertyContainer);
        let descriptionLabelInnerContainer = $("<div class='propertylabelinnercontainer'>").appendTo(descriptionLabelOuterContainer);
        let descriptionControlOuterContainer = $("<div class='wfpropertycontroloutercontainer'>").appendTo(that.descriptionPropertyContainer);
        let descriptionControlInnerContainer = $("<div class='wfpropertycontrolinnercontainer'>").appendTo(descriptionControlOuterContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("wf_variable_prop_id") + "</label>").appendTo(idLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("wf_variable_prop_type") + "</label>").appendTo(typeLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("wf_variable_prop_isarray") + "</label>").appendTo(isArrayLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("wf_variable_prop_value") + "</label>").appendTo(valueLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("wf_variable_prop_description") + "</label>").appendTo(descriptionLabelInnerContainer);
        let idInput = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(idControlInnerContainer);
        let typeInput = $("<input style='width:100%'>").appendTo(typeControlInnerContainer);
        let isArrayInput = $("<input type='checkbox' >").appendTo(isArrayControlInnerContainer);
        let valueInput = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(valueControlInnerContainer);
        let descriptionInput = $("<textarea class='wfInput k-textbox wfTextArea' rows='1'>").appendTo(descriptionControlInnerContainer);
        that.idPropertyContainer.on("click", (e) => {
            if (that.additionalContainer.hasClass("wfhideproperty"))
                that.additionalContainer.removeClass("wfhideproperty");
            else
                that.additionalContainer.addClass("wfhideproperty");
        });
        idInput.val(this.variable.Id);
        idInput.on("input", (e) => {
            let oldId = that.variable.Id;
            that.variable.Id = idInput.val().toString();
            let searchResult = that.manager.getSearchResult(oldId, oldId, "Variable");
            if (searchResult) {
                for (let searchProp of searchResult.Properties) {
                    that.manager.removeSearchProperty(searchResult.ElemId, searchProp.Id, searchResult.Type, searchProp.Property);
                    that.clearSearchResult(searchProp.Property);
                    that.manager.refreshSearchGrid();
                    if (searchProp.Property === "Variable:Id")
                        that.manager.checkPropertyChange(that.variable.Id, that.variable.Id, searchResult.Type, "Variable:Id", that.variable.Id);
                    else {
                        that.manager.addSearchResult(that.variable.Id, that.variable.Id, "Variable", searchProp.Property);
                        that.manager.refreshSearchGrid();
                        that.markSearchResult(searchProp.Property);
                    }
                }
            }
            else
                that.manager.checkPropertyChange(that.variable.Id, that.variable.Id, "Variable", "Variable:Id", that.variable.Id);
            this.manager.addHistoryObject();
        });
        if (this.variable.IsArray)
            isArrayInput.attr("data-hasvalue", "true").prop("checked", "checked");
        isArrayInput.on("change", e => {
            that.variable.IsArray = isArrayInput.prop("checked");
        });
        valueInput.val(this.variable.InitialValue);
        valueInput.on("input", e => {
            that.variable.InitialValue = valueInput.val().toString();
            that.variable.Value = valueInput.val().toString();
            that.manager.checkPropertyChange(that.variable.Id, that.variable.Id, "Variable", "Variable:Value", valueInput.val().toString());
            this.manager.addHistoryObject();
        });
        descriptionInput.val(this.variable.Description);
        descriptionInput.on("input", (e) => {
            that.variable.Description = descriptionInput.val().toString();
            that.manager.checkPropertyChange(that.variable.Id, that.variable.Id, "Variable", "Variable:Description", descriptionInput.val().toString());
            this.manager.addHistoryObject();
        });
        let typeCombobox = typeInput.kendoComboBox({
            dataSource: that.manager.m_typeNames,
            filter: "contains",
            change: (e) => {
                let val = e.sender.value();
                if (val && e.sender.dataItem()) {
                    that.variable.Type = val;
                }
                else {
                    that.variable.Type = undefined;
                    e.sender.select(-1);
                }
                this.manager.addHistoryObject();
            },
        }).data("kendoComboBox");
        if (this.variable.Type) {
            typeInput.data("kendoComboBox").value(this.variable.Type);
        }
        if (that.manager.Mode === WfMode.View) {
            idInput.addClass("wfReadOnly");
            idInput.prop("readonly", true);
            typeInput.addClass("wfReadOnly");
            typeInput.prop("readonly", true);
            typeCombobox.enable(false);
            let target = typeCombobox.input.closest(".k-input");
            target.addClass("wfReadOnly");
            isArrayInput.attr("disabled", "disabled");
            valueInput.addClass("wfReadOnly");
            valueInput.prop("readonly", true);
            descriptionInput.addClass("wfReadOnly");
            descriptionInput.prop("readonly", true);
        }
    }
    remove() {
        this.container.remove();
    }
    markSearchResult(property) {
        let that = this;
        switch (property) {
            case "Variable:Id":
                that.idPropertyContainer.addClass("wfMark");
                break;
            case "Variable:Description":
                that.descriptionPropertyContainer.addClass("wfMark");
                if (!that.isExpanded())
                    that.expand();
                break;
            case "Variable:Value":
                that.valuePropertyContainer.addClass("wfMark");
                if (!that.isExpanded())
                    that.expand();
                break;
        }
    }
    markError(property) {
        let that = this;
        switch (property) {
            case "Variable:Id":
                that.idPropertyContainer.addClass("wfpropertyerroritem");
                break;
            case "Variable:Description":
                that.descriptionPropertyContainer.addClass("wfpropertyerroritem");
                if (!that.isExpanded())
                    that.expand();
                break;
            case "Variable:Value":
                that.valuePropertyContainer.addClass("wfpropertyerroritem");
                if (!that.isExpanded())
                    that.expand();
                break;
        }
        this.container.addClass("wfpropertyerroritem");
    }
    clearError(property) {
        let that = this;
        switch (property) {
            case "Variable:Id":
                that.idPropertyContainer.removeClass("wfpropertyerroritem");
                break;
            case "Variable:Description":
                that.descriptionPropertyContainer.removeClass("wfpropertyerroritem");
                break;
            case "Variable:Value":
                that.valuePropertyContainer.removeClass("wfpropertyerroritem");
                break;
        }
    }
    clearSearchResult(property) {
        let that = this;
        switch (property) {
            case "Variable:Id":
                that.idPropertyContainer.removeClass("wfMark");
                break;
            case "Variable:Description":
                that.descriptionPropertyContainer.removeClass("wfMark");
                break;
            case "Variable:Value":
                that.valuePropertyContainer.removeClass("wfMark");
                break;
        }
    }
    isExpanded() {
        return !this.additionalContainer.hasClass("wfhideproperty");
    }
    expand() {
        this.additionalContainer.removeClass("wfhideproperty");
    }
    collapse() {
        this.additionalContainer.addClass("wfhideproperty");
    }
}
